
const translations = {
    "Notice!": "Märka!",
    "Are you sure that you want to delete this?": "Är du säker på att du vill ta bort detta?",
    "Confirm": "Bekräfta",
    "Cancel": "Avbryt",
    "Min": "Min",
    "Max": "Max",
    "Before": "Före",
    "After": "Efter",
    "w": "v",
    "week": "vecka",
    "weeks": "veckor",
    "d": "d",
    "day": "dag",
    "days": "dagar",
    "Due date": "Förfallodatum",
    "Start date": "Startdatum",
    "Internal date": "Internt datum",
    "Notes": "Anteckningar",
    "Document": "Dokument",
    "Email": "E-post",
    "Billing": "Fakturering",
    "Add": "Lägg till",
    "Archived": "Arkiverade",
    "Cancelled": "Avbruten",
    "Active": "Aktiv",
    "Inactive": "Inaktiv",
    "Client company": "Kundföretag",
    "General info": "Allmän information",
    "Digitisation of client documents": "Digitalisering av kundhandlingar",
    "Client portal": "Kundportal",
    "Documents": "Dokument",
    "Members": "Medlemmar",
    "Preferences": "Inställningar",
    "Yes": "Ja",
    "No": "Nej",
    "Total hours": "Totalt antal timmar",
    "Extra hours": "Extra timmar",
    "Client": "Kund",
    "Tasks": "Uppgifter",
    "Disable Uku’s task templates": "Inaktivera Ukus uppgiftsmallar",
    "Set the estimation as time when the exact value is not entered": "Ställ in uppskattningen som tid när det exakta värdet inte anges",
    "Checklist must be completed to finish the task": "Checklista måste fyllas i för att slutföra uppgiften",
    "Disable topic management for members": "Inaktivera ämneshantering för medlemmar",
    "Disable time edit for members": "Inaktivera tidsredigering för medlemmar",
    "Allow time entries in future": "Tillåt tidsangivelser i framtiden",
    "Show all dependent tasks in the calendar": "Show all dependent tasks in the calendar",
    "Clients": "Kunder",
    "Disable adding new clients for members": "Inaktivera tillägg av nya klienter för medlemmar",
    "Only administrators can edit documents": "Endast administratörer kan redigera dokument",
    "Allow digitisation of client documents": "Tillåt digitalisering av kunddokument",
    "Use my Microsoft account": "Använd mitt Microsoft-konto",
    "Disconnect my Microsoft account": "Koppla från mitt Microsoft-konto",
    "Connect my Microsoft account": "Anslut mitt Microsoft-konto",
    "Use my google account": "Använd mitt Google-konto",
    "Connect my google account": "Anslut mitt Google-konto",
    "Disconnect my google account": "Koppla bort mitt Google-konto",
    "Use my Xero account": "Use my Xero account",
    "Connect my Xero account": "Connect my Xero account",
    "Disconnect my Xero account": "Disconnect my Xero account",
    "Emails": "E-post",
    "Daily agenda": "Daglig dagordning",
    "Unread notifications": "Olästa aviseringar",
    "Task assigned to me": "Uppgift tilldelad mig",
    "Weekly summary": "Veckans sammanfattning",
    "Monthly summary": "Månads sammanställning",
    "Updates and tips": "Uppdateringar och tips",
    "Overdue": "Förfallen",
    "1 day": "1 dag",
    "1 day overdue": "1 dag försenad",
    "{0} days": "{0} dagar",
    "{0} days overdue": "{0} dagar försenade",
    "{0} minute ago": "{0} minut sedan",
    "{0} minutes ago": "{0} minuter sedan",
    "{0} hour ago": "{0} timme sedan",
    "{0} hours ago": "{0} timmar sedan",
    "Sunday": "Söndag",
    "Monday": "Måndag",
    "Tuesday": "Tisdag",
    "Wednesday": "Onsdag",
    "Thursday": "Torsdag",
    "Friday": "Fredag",
    "Saturday": "Lördag",
    "Sun": "Sön",
    "Mon": "Mån",
    "Tue": "Tis",
    "Wed": "Ons",
    "Thu": "Tor",
    "Fri": "Fre",
    "Sat": "Lör",
    "January": "Januari",
    "February": "Februari",
    "March": "Mars",
    "April": "April",
    "May": "Maj",
    "June": "Juni",
    "July": "Juli",
    "August": "Augusti",
    "September": "September",
    "October": "Oktober",
    "November": "November",
    "December": "December",
    "Jan": "Jan",
    "Feb": "Feb",
    "Mar": "Mars",
    "Apr": "Apr",
    "Jun": "Jun",
    "Jul": "Jul",
    "Aug": "Aug",
    "Sep": "Sep",
    "Oct": "Okt",
    "Nov": "Nov",
    "Dec": "Dec",
    "Today": "Idag",
    "Yesterday": "Igår",
    "Day": "Dag",
    "Days": "Dagar",
    "+{0} d": "+{0} d",
    "+{0} wd": "+{0} WD",
    "Weekly {0}": "Veckans {0}",
    "Every {0}. week {1}": "Varje {0}. vecka {1}",
    "{0}": "{0}",
    "Monthly {0}. d": "Månatlig {0}. d",
    "Every {0}. month {1}. d": "Varje {0}. månad {1}. d",
    "{0}. d": "{0}. d",
    "Quarterly {0}. month {1}. d": "Kvartalsvis {0}. månad {1}. d",
    "Every {0}. quarter {1}. month {2}. d": "Varje {0}. kvartalet {1}. månad {2}. d",
    "{0}. month {1}. d": "{0}. månad {1}. d",
    "Yearly {0}": "Årlig {0}",
    "Every {0}. year {1}": "Varje {0}. år {1}",
    "Mo": "Mån",
    "Tu": "Ti",
    "We": "Ons",
    "Th": "Tors",
    "Fr": "Fr",
    "Sa": "Lö",
    "Su": "Sö",
    "and": "och",
    "{0}w": "{0}w",
    "{0}d": "{0}d",
    "before": "före",
    "after": "efter",
    "Project": "Projekt",
    "Quarter": "Kvartal",
    "Add logo": "Add logo",
    "Add your photo": "Lägg till ditt foto",
    "Adding file failed": "Det gick inte att lägga till filen",
    "Please check the file.": "Kontrollera filen.",
    "You can only add pictures.": "Du kan bara lägga till bilder.",
    "Error": "Fel",
    "Create new topic": "Skapa nytt ämne",
    "Name": "Namn",
    "Close": "Stäng",
    "Find topic...": "Hitta ämne...",
    "New topic": "Nytt ämne",
    "Invalid format": "Ogiltigt format",
    "Demo company account": "Konto för demoföretag",
    "Demo account will be deleted later. Do this for testing purposes only!": "Demokontot kommer att raderas senare. Gör detta endast i testsyfte!",
    "Subscribe": "Prenumerera",
    "Start demo": "Starta demo",
    "End demo": "Avsluta demo",
    "Free trial is expired - {0}": "Den kostnadsfria provperioden har löpt ut – {0}",
    "Free trial {1} {2} left - {0}": "Gratis provperiod {1} {2} kvar - {0}",
    "Add time": "Lägg till tid",
    "Billable": "Fakturerbar",
    "Date": "Datum",
    "Start": "Start",
    "End": "Slut",
    "Duration": "Varaktighet",
    "Split duration equally": "Dela varaktigheten lika",
    "Required field": "Obligatoriskt fält",
    "Members list": "Medlemslista",
    "Edit fields": "Redigera fält",
    "Maximum number of selected columns has been exceeded": "Det maximala antalet markerade kolumner har överskridits",
    "If you want to add a new column to the report, please remove an existing one first.": "Om du vill lägga till en ny kolumn i rapporten måste du först ta bort en befintlig.",
    "Snooze until...": "Snooze tills...",
    "Select date & time": "Välj datum och tid",
    "Tomorrow": "I morgon",
    "Later this week": "Senare i veckan",
    "Next week": "Nästa vecka",
    "Add task": "Lägg till uppgift",
    "Checklist": "Checklista",
    "Start timer": "Starta timern",
    "Add an item": "Lägg till ett objekt",
    "Add checklist item": "Lägg till checklista",
    "Convert to a task": "Konvertera till en uppgift",
    "Delete": "Radera",
    "Delegate to...": "Delegera till...",
    "Please select tasks from the same account": "Välj uppgifter från samma konto",
    "Follow": "Följ",
    "Expand sidebar": "Visa sidofältet",
    "Nicely done!": "Snyggt gjort!",
    "You've finished all your tasks, take a second to recharge": "Du är klar med alla dina uppgifter, ta en sekund för att ladda batterierna",
    "Search tasks...": "Sök uppgifter...",
    "Search": "Sök",
    "select/unselect all": "Markera/avmarkera alla",
    "Add new client": "Lägg till ny kund",
    "Account": "Konto",
    "Client name": "Kundnamn",
    "Select client": "Välj kund",
    "New client": "Ny kund",
    "Must be an integer": "Måste vara ett heltal",
    "Must be a number": "Måste vara en siffra",
    "Dashboard": "Kontrollpanel",
    "Calendar": "Kalender",
    "Report": "Rapportera",
    "Monitoring": "Monitorering",
    "Suppliers": "Leverantörer",
    "Events": "Evenemang",
    "Projects": "Projekt",
    "Help": "Hjälp",
    "Invite a friend": "Invite a friend",
    "Settings & Apps": "Inställningar och appar",
    "Profile": "Profil",
    "Collapse menu": "Komprimera menyn",
    "Expand menu": "Expandera meny",
    "Are you sure to delete this attachment?": "Är du säker på att du vill ta bort den här bilagan?",
    "Select": "Välj",
    "Edit contacts": "Redigera kontakter",
    "Add member": "Lägg till medlem",
    "Add note": "Lägg till anteckning",
    "Open": "Open",
    "Reports": "Rapporter",
    "Billing notes": "Fakturor",
    "Pinned notes": "Fästa anteckningar",
    "Sub-companies": "Underföretag",
    "Contacts": "Kontakter",
    "Event info": "Evenemangsinformation",
    "Project info": "Information om projektet",
    "Summary": "Sammanfattning",
    "Task": "Uppgift",
    "Time": "Tid",
    "Collapse sidebar": "Dölja sidofältet",
    "Client Overview": "Översikt över kunder",
    "Event Overview": "Översikt över händelser",
    "Project Overview": "Projektöversikt",
    "Edit client": "Ändra kund",
    "Edit event": "Ändra evenemang",
    "Edit project": "Ändra projekt",
    "Show all": "Visa alla",
    "Collapse": "Minimera",
    "by": "av",
    "View all": "Visa alla",
    "Copied to clipboard": "Kopierat till urklipp",
    "Client portal invite sent on {0}": "Client portal invite sent on {0}",
    "Client portal invite has not been sent": "Client portal invite has not been sent",
    "Resend invite": "Skicka om inbjudan på nytt",
    "Send invite": "Skicka inbjudan",
    "Invite sent": "Inbjudan skickad",
    "Add company event": "Lägg till företagsevent",
    "Company": "Företag",
    "Info": "Info",
    "Holiday": "Semester",
    "All day(s)": "Alla dagar:",
    "End date": "Slutdatum",
    "From": "Från",
    "Until": "Tills",
    "Hours": "Timmar",
    "Link": "Länk",
    "Save": "Spara",
    "Are you sure that you want to delete this company calendar event?": "Är du säker på att du vill ta bort den här företagskalenderhändelsen?",
    "Location of client folder in your document management system": "Location of client folder in your document management system",
    "Defined main folder": "Defined main folder",
    "Custom folder": "Custom folder",
    "Add new role": "Lägg till ny roll",
    "New role": "Ny roll",
    "Access enabled": "Åtkomst aktiverad",
    "Waiting for files": "Väntar på filer",
    "Uploaded": "Uppladdat",
    "Uploading...": "Laddar upp...",
    "Client members": "Kunder medlemmar",
    "Email settings": "E-postinställningar",
    "Or connect new email address": "Eller anslut ny e-postadress",
    "Connect with Microsoft Exchange or other email server (SMTP)": "Ansluta till Microsoft Exchange eller annan e-postserver (SMTP)",
    "Test email sent": "Test-e-post skickad",
    "Email address": "E-postadress",
    "Reply address": "Svara adress",
    "Sender name": "Avsändarens namn",
    "Who can use?": "Vem kan använda?",
    "Client default address": "Klientens standardadress",
    "Invalid e-mail": "Ogiltig e-postadress",
    "Role": "Roll",
    "E-mail": "E-post",
    "Mobile phone": "Mobiltelefon",
    "Work phone": "Telefon till jobbet",
    "Language": "Språk",
    "Birthday": "Födelsedatum",
    "Are you sure to delete this contact?": "Är du säker på att du vill ta bort den här kontakten?",
    "Manage contact fields": "Hantera kontaktfält",
    "Administrative Assistant": "Administrativ assistent",
    "Board member": "Styrelseledamot",
    "CEO": "VD",
    "Add contact": "Lägg till kontakt",
    "Contact person": "Kontaktperson",
    "Leave page?": "Lämna sidan?",
    "Changes that you made may not be saved": "Ändringar som du har gjort kanske inte sparas",
    "Leave": "Lämna",
    "Validate tasks": "Validate tasks",
    "The Contact you are trying to delete is an assignee in {0} tasks. Remove the contact from tasks to continue.": "The Contact you are trying to delete is an assignee in {0} tasks. Remove the contact from tasks to continue.",
    "Continue": "Fortsätt",
    "Super! We're importing your clients...": "Super! Vi importerar dina kunder...",
    "Feel free to leave this page. We will pop up a notification when the import is prepared. Then you need to confirm the clients you want to add to Uku.": "Lämna gärna den här sidan. Vi kommer att dyka upp ett meddelande när importen är klar. Sedan måste du bekräfta de klienter du vill lägga till i Uku.",
    "Please wait...": "Vänligen vänta...",
    "Setup API keys": "Konfigurera API-nycklar",
    "You have two options": "Du har två alternativ",
    "how to setup API keys": "hur man ställer in API-nycklar",
    "Custom import": "Anpassad import",
    "To import clients and volume of work from !INTEGRATION, Uku needs !INTEGRATION API key for every client.": "Om du vill importera klienter och arbetsvolym från ! INTEGRATION, Uku behöver! INTEGRATION API-nyckel för varje klient.",
    "1. <span class=font-weight-medium>Continue</span> - Uku automatically creates API keys for every client": "1. <span class=\"font-weight-medium\">Fortsätt</span> - Uku skapar automatiskt API-nycklar för varje klient",
    "1. <span class=font-weight-medium>Custom import</span> - Uku connects only with existing UKU API keys. Create API keys manually in !INTEGRATION before import. Read:": "1. <span class=\"font-weight-medium\">Anpassad import</span> - Uku ansluter endast till befintliga UKU API-nycklar. Skapa API-nycklar manuellt i ! INTEGRATION före import. Läsa:",
    "(it takes a lot of time)": "(det tar mycket tid)",
    "Import Clients": "Importera klienter",
    "Country": "Land",
    "Please choose your country": "Välj ditt land",
    "Password": "Lösenord",
    "Start import": "Starta import",
    "Insert !INTEGRATION login details (it’s secure) to give one time access to import clients and API keys. Please note that you will get logged out from !INTEGRATION in other browsers.": "Infoga! INTEGRATION inloggningsuppgifter (det är säkert) för att ge engångsåtkomst till importklienter och API-nycklar. Observera att du kommer att loggas ut från ! INTEGRATION i andra webbläsare.",
    "Update invoice status": "Uppdatera fakturastatus",
    "Update now": "Uppdatera nu",
    "Daily @ 14:00": "Dagligen @ 14:00",
    "Daily @ 18:00": "Dagligen @ 18:00",
    "Updating invoice statuses, please wait...": "Uppdaterar fakturastatus, vänta...",
    "Your import is ready": "Importen är klar",
    "In the final step you need to confirm the clients you want to add to uku": "I det sista steget måste du bekräfta de klienter du vill lägga till i uku",
    "Let's go": "Kom så går vi",
    "Import again": "Importera igen",
    "Do you have new clients to import?": "Har du nya kunder att importera?",
    "Yes, i do": "Ja det gör jag",
    "View last import": "Visa senaste import",
    "Email server": "E-postserver",
    "Email provider": "E-postleverantör",
    "Host": "Uthyrare",
    "Port": "Port",
    "Security": "Säkerhet",
    "Sender email": "Avsändarens e-post",
    "Username": "Användarnamn",
    "Test connection": "Testa anslutning",
    "How to set up": "Så här ställer du in",
    "Only administrators can activate the app": "Endast administratörer kan aktivera appen",
    "You are in the waiting list": "Du står på väntelistan",
    "We onboard all applicants one by one": "Vi onboardar alla sökande en och en",
    "Connected": "Ansluten",
    "Activated": "Aktiverad",
    "Join waiting list": "Anmäl dig till väntelistan",
    "Activate": "Aktivera",
    "Unsubscribe from waiting list": "Avregistrera dig från väntelistan",
    "Deactivate app": "Inaktivera appen",
    "Disconnect": "Koppla ned",
    "Hide expanded content": "Hide expanded content",
    "Show trimmed content": "Show trimmed content",
    "Email not delivered": "E-postmeddelandet har inte levererats",
    "Sent, but fallback to Uku email": "Skickat, men återgå till Uku-e-post",
    "Unknown error": "Okänt fel",
    "to": "till",
    "automatically": "automatically",
    "in any minute": "i vilken minut som helst",
    "on {0},": "på {0},",
    "or": "eller",
    "Send now": "Skicka nu",
    "Uku will no longer send email": "Uku will no longer send email",
    "Uku <span class='subtitle-2'>is sending</span> email": "Uku <span class='subtitle-2'>skickar</span> e-post",
    "__From_email": "__From_email",
    "Set up email": "Konfigurera e-post",
    "Client default": "Standardklient",
    "Subject": "Ämne",
    "Edit email": "Redigera e-post",
    "Template": "Mall",
    "Cc": "Cc",
    "Bcc": "Bcc",
    "__To_email": "__To_email",
    "__Cc_email": "__Cc_email",
    "__Bcc_email": "__Bcc_email",
    "Add template": "Lägg till en mall",
    "Add automation": "Lägg till automatisering",
    "Add placeholder": "Lägga till platshållare",
    "Format text": "Formatera text",
    "Add attachment": "Lägg till bifogad fil",
    "Send": "Skicka",
    "Save automation": "Spara automatisering",
    "Choose email template": "Välj e-postmall",
    "All languages": "Alla språk",
    "No templates found.": "Inga mallar hittades.",
    "Edit email template": "Redigera e-postmall",
    "Are you sure you want to delete this template? Some tasks will be affected": "Är du säker på att du vill ta bort den här mallen? Vissa uppgifter kommer att påverkas",
    "Are you sure you want to delete this template?": "Är du säker att du vill radera den här mallfilen?",
    "Are you sure you want to save this template, the following tasks will be affected?": "Är du säker på att du vill spara den här mallen kommer följande uppgifter att påverkas?",
    "Template name": "Mallnamn",
    "Edit template": "Redigera mall",
    "Send email": "Skicka e-post",
    "on": "på",
    "Ok": "Ok",
    "Supplier": "Leverantör",
    "Event": "Evenemang",
    "Contact": "Kontakt",
    "Validation failed": "Validering misslyckades",
    "Saving supplier failed": "Att rädda leverantör misslyckades",
    "Saving client failed": "Det gick inte att spara klienten",
    "Saving project failed": "Det gick inte att spara projektet",
    "several values": "Flera värden",
    "values": "värden",
    "is": "är",
    "Add filter": "Lägg till filter",
    "Update": "Uppdatera",
    "forever": "föralltid",
    "Last week": "Förra veckan",
    "This week": "Denna vecka",
    "Last month": "Senaste månaden",
    "This month": "Denna månad",
    "Next month": "Nästa månad",
    "Last year": "Senaste året",
    "This year": "Detta år",
    "This quarter": "Detta kvartal",
    "Next quarter": "Nästa kvartal",
    "Last quarter": "Sista kvartalet",
    "Client group": "Kundgrupp",
    "Topic": "Ämne",
    "Member": "Medlem",
    "Primary member": "Primär medlem",
    "Client status": "Status som kund",
    "Active clients": "Aktiva klienter",
    "Inactive clients": "Inaktiva klienter",
    "All": "Alla",
    "Project status": "Projektstatus",
    "Member status": "Status som medlem",
    "Active members": "Aktiv medlem",
    "Limited members": "Begränsat antal medlemmar",
    "Inactive members": "Inaktiva medlemmar",
    "Contract status": "Kontraktets status",
    "Active contracts": "Aktiva avtal",
    "Pending contracts": "Pågående kontrakt",
    "Finished contracts": "Avslutade kontrakt",
    "Contract template": "Mall för avtal",
    "Payment recurrence": "Återkommande betalning",
    "Yearly": "Årlig",
    "Monthly": "Månadsvis",
    "Trial": "Provperiod",
    "Region": "Region",
    "Field": "Fält",
    "All tasks": "Alla uppgifter",
    "Todo": "Att göra",
    "Not done": "Inte gjort",
    "Done": "Klar",
    "Delayed": "Försenad",
    "Important": "Viktigt",
    "Extra work": "Extra arbete",
    "I Follow": "Jag följer",
    "Commented": "Kommenterad",
    "Tracked time": "Spårad tid",
    "Estimated": "Uppskattad",
    "Recurring task": "Återkommande uppgift",
    "Last import": "Senaste import",
    "Period": "Period",
    "Client search": "Sökning av kunder",
    "Voucher": "Rabattkupong",
    "Company status": "Företagets status",
    "Deleted": "Raderad",
    "All status": "All status",
    "Payment gateway": "Betalningsmodul",
    "All gateways": "Alla gateways",
    "Uku manually": "Uku manuellt",
    "Braintree": "Braintree",
    "Plan status": "Planera status",
    "All plans": "Alla planer",
    "Paid": "Betald",
    "Paid churn": "Betald churn",
    "Trial churn": "Bortfall av provversion",
    "Plan period": "Planperiod",
    "All periods": "Alla perioder",
    "Monthly plan": "Månadsplan",
    "Yearly plan": "Årlig plan",
    "Company search": "Sök efter företag",
    "User search": "Sök användare",
    "Name key search": "Namnnyckelsökning",
    "None filter": "Inget filter",
    "OK": "OK",
    "Start date cannot be later than due date": "Startdatum får inte vara senare än förfallodagen",
    "tasks": "uppgifter",
    "task(s) had errors": "Uppgiften/uppgifterna innehöll fel",
    "tasks selected": "Valda uppgifter",
    "Postpone": "Senarelägga",
    "Mark done": "Markera som klar",
    "Hide multiselect": "Dölj flerval",
    "Delete task(s)": "Ta bort uppgift(er)",
    "All of the data related to the task will be deleted": "Alla uppgifter som är relaterade till uppgiften kommer att raderas",
    "Some tasks include other people. Are you sure you want to delete?": "Vissa uppgifter inkluderar andra personer. Är du säker på att du vill ta bort?",
    "Time has been tracked to some of the selected activities. Are you sure you want to delete?": "Tiden har spårats till några av de valda aktiviteterna. Är du säker på att du vill ta bort?",
    "Time has been tracked to some of the selected activities. Some tasks include other people. Are you sure you want to delete?": "Tiden har spårats till några av de valda aktiviteterna. Vissa uppgifter inkluderar andra personer. Är du säker på att du vill ta bort?",
    "task(s) were not marked done": "Uppgift(er) har inte markerats som klar",
    "Please check if the checklist has been completed or time is entered and they are assigned to you": "Kontrollera om checklistan har fyllts i eller om tid har angetts och de har tilldelats dig",
    "task(s) were not deleted": "Uppgift(er) har inte tagits bort",
    "task(s) time was not updated": "Uppgiftens tid uppdaterades inte",
    "Please make sure that you can add time to task": "Se till att du kan lägga till tid till uppgiften",
    "invoice table row": "Faktura tabell rad",
    "invoice table row(s) had errors": "Fakturatabellens rad(er) innehöll fel",
    "invoice table row(s) selected": "Valda rader i fakturatabellen",
    "Create": "Skapa",
    "Mark paid": "Markera betald",
    "Send to client": "Skicka till kund",
    "Recalculate": "Räkna om",
    "Export to {0}": "Exportera till {0}",
    "Update Status from {0}": "Uppdatera status från {0}",
    "Void invoice": "Ogiltig faktura",
    "Delete invoice": "Ta bort faktura",
    "Restore invoice": "Återställa faktura",
    "Mark unpaid": "Markera som obetald",
    "Invoices": "Fakturor",
    "Download to Excel": "Ladda ner till Excel",
    "Revenue split": "Fördelning av intäkter",
    "Tax": "Skatt",
    "Description": "Beskrivning",
    "Percent": "Procent",
    "Integration Id": "Integrations-ID",
    "Integration Code": "Kod för integrering",
    "Name on invoice": "Namn på faktura",
    "Restore": "Återställ",
    "Archive": "Arkiv",
    "Hide": "Dölj",
    "Are you sure?": "Är du säker?",
    "Invoice seller": "Invoice seller",
    "Company name": "Företagsnamn",
    "Address": "Adress",
    "Company number": "Organisationsnummer",
    "Tax number": "Tax number",
    "Bank": "Bank",
    "IBAN": "IBAN",
    "Delete logo": "Radera logotyp",
    "Upload logo file": "Ladda upp logotypfil",
    "Max. dimensions 130 x 130 px": "Max. dimensions 130 x 130 px",
    "Import finished!": "Importen är klar!",
    "Failed to import {0} records": "Det gick inte att importera {0} poster",
    "Download report": "Ladda ned rapport",
    "Result: added {0}, updated {1}, skipped {2}, failed to import {3}": "Resultat: lade till {0}, uppdaterade {1}, hoppade över {2}, kunde inte importera {3}",
    "Result: added {0}, updated {1}, skipped {2}": "Resultat: lagt till {0}, uppdaterat {1}, hoppat över {2}",
    "What’s next?": "Vad händer härnäst?",
    "To work effectively with your client base, complete the following steps:": "Utför följande steg för att arbeta effektivt med din kundbas:",
    "Read more ›": "Läs mer >",
    "Next you will only see active imported clients. To see all clients, remove “Last import” filter.": "Därefter kommer du bara att se aktiva importerade klienter. Om du vill se alla klienter tar du bort filtret \"Senaste import\".",
    "View clients": "Visa kunder",
    "Add <b>primary member</b> to every client.": "Lägg till <b>primär medlem</b> i varje klient.",
    "Add <b>task plan</b> to automate recurring tasks.": "Lägg till <b>uppgiftsplan</b> för att automatisera återkommande uppgifter.",
    "Setup automatic monthly summary under {0} app in Uku to import volume of work.": "Ställ in automatisk månadssammanfattning under {0} app i Uku för att importera arbetsvolym.",
    "Title": "Titel",
    "Field type": "Fälttyp",
    "Field name": "Fältnamn",
    "Client section": "Client section",
    "Choices": "Val",
    "Type each choice on a separate line": "Skriv varje alternativ på en separat rad",
    "Required": "Obligatorisk",
    "For all topics": "För alla ämnen",
    "For specific topics": "För specifika ämnen",
    "Topics": "Ämnen",
    "Non-billable": "Ej fakturerbar",
    "Edit task custom field": "Redigera anpassat uppgiftsfält",
    "Add task custom field": "Lägg till anpassat uppgiftsfält",
    "Edit client custom field": "Redigera anpassat klientfält",
    "Add client custom field": "Lägg till anpassat klientfält",
    "Choice {0}": "Val {0}",
    "Are you sure that you want to delete this custom field?": "Är du säker på att du vill ta bort det här anpassade fältet?",
    "Warning!": "Varning!",
    "This custom field is in use. Do you wish to archive it?": "Det här anpassade fältet används. Vill du arkivera den?",
    "Reconnect": "Återkoppla",
    "Send test email": "Skicka testmeddelande",
    "Email address or username": "E-postadress eller användarnamn",
    "Other": "Annat",
    "Set default email server for company": "Ställ in standardserver för e-post för företag",
    "My default email": "Min standard-e-postadress",
    "Depends on": "Beror på",
    "Todo - Blocking": "Att göra - Blockera",
    "In progress - Blocking": "Pågår – spärra",
    "In progress": "Påbörjad",
    "Client code": "Klient kod",
    "Primary user": "Primär användare",
    "Added date": "Tillagt datum",
    "Updated": "Uppdaterad",
    "Contract count": "Antal kontrakt",
    "Integration": "Integration",
    "No data available": "Inget data tillgängligt",
    "No results found": "Inga resultat hittades",
    "Loading": "Laddar",
    "Sort by": "Sortera efter",
    "{0}-{1} of {2}": "{0}-{1} av {2}",
    "Rows per page": "Rader per sida",
    "Ongoing": "Pågående",
    "important": "viktig",
    "Read more": "Läs mer",
    "Add to previous time entry": "Lägg till föregående tidspost",
    "Add to next time entry": "Lägg till i nästa tidsangivelse",
    "Add new task": "Lägg till ny uppgift",
    "Cut previous time entry": "Klipp ut föregående tidsinmatning",
    "Cut next time entry": "Klipp ut nästa gång inmatning",
    "Missing time entry": "Tidsangivelse saknas",
    "Overlapping time entries": "Överlappande tidsposter",
    "Member from custom fields": "Medlem från anpassade fält",
    "Delegated to": "Delegerad till",
    "Delegated by": "Delegerad av",
    "Visible members": "Synliga medlemmar",
    "Member type": "Medlem Typ",
    "Groups": "Grupper",
    "Custom field": "Anpassat fält",
    "Contact search": "Sökning av kontakter",
    "Task start": "Uppgiftens start",
    "Task due": "Uppgift förfaller",
    "Task finish": "Uppgift slutförd",
    "Custom date": "Anpassat datum",
    "Never": "Aldrig",
    "Referral status": "Referral status",
    "Invited": "Inbjuden",
    "Registered": "Registered",
    "Earned": "Earned",
    "Agreed work is still expected": "Överenskommet arbete förväntas fortfarande",
    "Accepted flextime": "Accepterad flextid",
    "Declined flextime": "Minskad flextid",
    "Cancelled flextime": "Avbruten flextid",
    "Updated flextime": "Uppdaterad flextid",
    "Calendar deleted": "Kalender har raderats",
    "Calendar created": "Kalendern har skapats",
    "Calendar approved": "Kalender godkänd",
    "Calendar declined": "Kalendern avböjde",
    "Calendar updated": "Kalendern har uppdaterats",
    "Flextime balance updated": "Flextidssaldot uppdaterat",
    "Flextime": "Flextid",
    "Vacation": "Semester",
    "Balance": "Saldo",
    "Comment": "Kommentar",
    "History": "Historik",
    "Action": "Åtgärd",
    "Who": "Vem",
    "Take a vacation or mark an absence": "Ta semester eller markera frånvaro",
    "Away": "Ej tillgänglig",
    "Flextime bonus": "Flextidsbonus",
    "Approver": "Godkännare",
    "Vacation available": "Semester tillgänglig",
    "Type": "Typ",
    "Reduce agreed working hours": "Minska den avtalade arbetstiden",
    "Reject": "Avvisa",
    "Approve": "Godkänn",
    "away_type_Away": "away_type_Away",
    "Sick leave": "Sjukledighet",
    "Parental leave": "Föräldraledighet",
    "Working hours": "Working hours",
    "Mon-Fri, 40h weekly, 8h daily": "Mon-Fri, 40h weekly, 8h daily",
    "Customize": "Customize",
    "Total": "Totalt",
    "Settings": "Inställningar",
    "Work on holidays": "Arbete på helgdagar",
    "Get {0} in cash for every referral who becomes a Uku client.": "Get {0} in cash for every referral who becomes a Uku client.",
    "Copy your invite link": "Copy your invite link",
    "Hide message": "Hide message",
    "View message": "View message",
    "Your statistics": "Your statistics",
    "Copy message": "Copy message",
    "How it works": "How it works",
    "Invite your friends to Uku, and we'll give a free month of Uku - and show them how to boost their business.": "Invite your friends to Uku, and we'll give a free month of Uku - and show them how to boost their business.",
    "After your referral becomes a paying Uku client, we send you a {0} gift card.": "After your referral becomes a paying Uku client, we send you a {0} gift card.",
    "More ways to earn cash": "More ways to earn cash",
    "referral_email_content": "referral_email_content",
    "Write feedback for Uku and get <a href='/api/help_link/referral_feedback' target='_blank'>{0} gift card here</a>": "Write feedback for Uku and get <a href='/api/help_link/referral_feedback' target='_blank'>{0} gift card here</a>",
    "Expand": "Expandera",
    "Wait until event status": "Vänta tills händelsestatus",
    "Wait until project status": "Vänta tills projektstatus",
    "Week(s)": "Vecka/veckor",
    "Day(s)": "Dag(ar)",
    "Rule": "Regel",
    "Depends on event": "Beror på händelse",
    "Depends on project": "Beror på projekt",
    "Due date in": "Förfallodag i",
    "Status": "Status",
    "Select event": "Välj evenemang",
    "Select project": "Välj projekt",
    "Find event...": "Hitta evenemang...",
    "Find project...": "Hitta projekt...",
    "Custom recurrence": "Anpassad upprepning",
    "Every": "Varje",
    "In case of holiday": "Vid semester",
    "Set time": "Fastställ tid",
    "Start time": "Starttid",
    "Repeat from": "Upprepa från",
    "Previous repeat from: {0}": "Föregående upprepning från: {0}",
    "On date": "På datumet",
    "Plus days": "Plusdagar",
    "Due date time": "Förfallodatum och tid",
    "Remove recurrence": "Ta bort upprepning",
    "Repeat": "Upprepa",
    "month": "månad",
    "quarter": "kvartal",
    "year": "år",
    "1st month": "1:a månaden",
    "2nd month": "2:a månaden",
    "3rd month": "3:e månaden",
    "Day {0}": "Dag {0}",
    "Show before": "Visa före",
    "Keep the day": "Behåll dagen",
    "Show after": "Visa efter",
    "From start date": "Från startdatum",
    "From beginning of the month": "Från början av månaden",
    "All days (Mon to Sun)": "Alla dagar (mån till sön)",
    "Mon to Fri (incl. holidays)": "Mån till fre (inkl. helgdagar)",
    "Mon to Fri (excl. holidays)": "Mån till fre (exkl. helgdagar)",
    "1st": "1st",
    "2nd": "2:a",
    "3rd": "3:e",
    "Does not repeat": "Upprepas inte",
    "Daily": "Dagligen",
    "Weekly on {0}": "Varje vecka på {0}",
    "Monthly on day {0}": "En gång i månaden dag {0}",
    "Quarterly on {0} month {1} day": "Kvartalsvis {0} månad {1} dag",
    "Yearly on {0} {1}": "Årligen på {0} {1}",
    "Custom...": "Anpassad...",
    "Incorrect time": "Felaktig tid",
    "Add repeat": "Lägg till upprepning",
    "Email added to queue": "E-post har lagts till i kön",
    "Communication timeline": "Tidslinje för kommunikation",
    "Activate Email App in App Store to send automated emails and view your past and future communication in one place.": "Aktivera e-postappen i App Store för att skicka automatiska e-postmeddelanden och se din tidigare och framtida kommunikation på ett och samma ställe.",
    "Go to App Store": "Gå till App Store",
    "Unknown": "Okänd",
    "<b>Email</b> from": "<b>E-post</b> från",
    "To": "Till",
    "Planned": "Planerad",
    "Automated emails scheduled to be sent in the future": "Automatiserade e-postmeddelanden som är planerade att skickas i framtiden",
    "Send e-mail": "Skicka e-post",
    "Template unlinked": "Mallen har tagits bort",
    "Icon": "Ikon",
    "Link name": "Link name",
    "Link URL": "Link URL",
    "Open in new tab": "Open in new tab",
    "Visible": "Synlig",
    "External": "External",
    "Not external": "Not external",
    "Company default": "Företagets betalningsinställelse",
    "Not visible": "Not visible",
    "Use company default": "Use company default",
    "or choose icon": "or choose icon",
    "Find member...": "Hitta medlem...",
    "I'll take it": "Jag tar det",
    "Remove me": "Ta bort mig",
    "Remove from task": "Ta bort från uppgift",
    "Learn more": "Läs mer",
    "Company settings edit is disabled by owner": "Redigering av företagsinställningar har inaktiverats av ägaren",
    "<b>Exported</b> {0} to {1}": "<b>Exporterad</b> {0} till {1}",
    "<b>Sent to client</b> {0} from {1}": "<b>Sent to client</b> {0} from {1}",
    "<b>Paid {0}</b> {1}": "<b>Betalad {0}</b> {1}",
    "<b>Annulled</b> {0}": "<b>Ogiltigförklarade</b> {0}",
    "Do you wish to mark the task done for everyone?": "Vill du markera uppgiften som klar för alla?",
    "No, remove me": "Nej, ta bort mig",
    "Task won’t be marked done, but user is removed from the assignees and added to the followers of the task": "Uppgiften markeras inte som klar, men användaren tas bort från de tilldelade personerna och läggs till i uppgiftens följare",
    "Invalid email": "Ogiltig e-postadress",
    "Accounting": "Bokföring",
    "General": "Allmänt",
    "Advertising / Marketing/ PR": "Reklam / Marknadsföring / PR",
    "Architecture": "Arkitektur",
    "Construction": "Byggprodukter",
    "Consulting - IT, software": "Konsulttjänster - IT, mjukvara",
    "Consulting - Management": "Konsulttjänster - Management",
    "Finance": "Finans",
    "Legal": "Juridisk",
    "Medicine / Pharmacy ": "Medicin / Farmaci ",
    "Non-profit": "Ideellt",
    "Web design": "Webbdesign",
    "Web development": "Webbutveckling",
    "Max 140 characters": "Max 140 tecken",
    "Please complete the checklist": "Fyll i checklistan",
    "It is required to mark all checklist items as done": "Det är obligatoriskt att markera alla checklistepunkter som klara",
    "Please enter time spent": "Ange tidsåtgång",
    "Inserting time is essential for this client": "Att sätta in tid är viktigt för den här klienten",
    "Only me": "bara jag",
    "Private": "Privat",
    "Edit note": "Redigera",
    "Add additional information about the client, such as special agreements, passwords, etc.": "Lägg till ytterligare information om kunden, t.ex. specialavtal, lösenord etc.",
    "Edit": "Redigera",
    "Workdays": "Arbetsdagar",
    "Workhours": "Arbetstid",
    "Weeks": "Veckor",
    "Clear filters": "Återställ filter",
    "Save filters": "Spara filter",
    "Expected": "Förväntad",
    "Estimation": "Uppskattning",
    "Do you also want to postpone the due date?": "Vill du också flytta fram förfallodagen?",
    "{0} week": "{0} vecka",
    "{0} weeks": "{0} veckor",
    "Vacations": "Semester",
    "Holidays": "Helgdagar",
    "Tax dates": "Datum för beskattning",
    "Accounting news": "Bokföring nyheter",
    "Company events": "Företagets evenemang",
    "Member birthdays": "Medlemmars födelsedagar",
    "Contact birthdays": "Kontakt födelsedagar",
    "Group items": "Gruppera objekt",
    "Don't group": "Gruppera inte",
    "{0} away": "{0} bort",
    "Member birthday | Member birthdays": "Medlemmens födelsedag | Medlemmars födelsedagar",
    "Contact birthday | Contact birthdays": "Kontakt födelsedag | Kontakt födelsedagar",
    "Contact birthday": "Kontakt födelsedag",
    "Member birthday": "Medlemmens födelsedag",
    "Are you sure you wish to delete this link?": "Är du säker på att du vill ta bort den här länken?",
    "Reference name": "Referens namn",
    "Reference link": "Referens länk",
    "Free trial": "Gratis testperiod",
    "Solo": "Solo",
    "Team": "Team",
    "Enterprise": "Företag",
    "Mini Uku": "Mini Uku",
    "Chrome browser plugin for Uku to manage your task, clients and track time.": "Chrome-webbläsarplugin för Uku för att hantera din uppgift, kunder och spåra tid.",
    "Setup task/job plans to automate your workflow, add topics, custom fields and modify your preferences.": "Ställ in uppgifts-/jobbplaner för att automatisera ditt arbetsflöde, lägga till ämnen, anpassade fält och ändra dina inställningar.",
    "Setup client groups, custom fields and modify your preferences.": "Ställ in klientgrupper, anpassade fält och ändra dina inställningar.",
    "test": "test",
    "Anti Money Laundering": "Bekämpning av penningtvätt",
    "Setup your customer AML and get instant reminders when auditing is due.": "Ställ in din kund-AML och få omedelbara påminnelser när det är dags för revision.",
    "flextime_description": "flextime_description",
    "Smart Accounts": "Smarta konton",
    "Automatically imports work statistics from your accounting software.": "Importerar automatiskt arbetsstatistik från ditt bokföringsprogram.",
    "Merit Aktiva": "Merit Aktiva",
    "360 Księgowość": "360 Księgowość",
    "Speed up your client billing process with pricelists and smart contracts.": "Snabba upp din kundfaktureringsprocess med prislistor och smarta kontrakt.",
    "Visual report will tell you exactly how profitable or unprofitable your client is.": "Visuell rapport kommer att berätta exakt hur lönsam eller olönsam din kund är.",
    "Emailing description": "Beskrivning av e-postning",
    "e-conomic": "e-conomic",
    "Sync client data from Uku to e-conomic and vice versa. View sales ledger information for each client.": "Synkronisera klientdata från Uku till e-conomic och vice versa. Visa kundreskontrainformation för varje kund.",
    "Xero": "Xero Xero",
    "xero_description": "xero_description",
    "QuickBooks": "QuickBooks (på engelska)",
    "quickbooks_description": "quickbooks_description",
    "Tripletex": "Tripletex",
    "tripletex_description": "tripletex_description",
    "Scoro": "Scoro",
    "Export sales invoices.": "Exportera försäljningsfakturor.",
    "Fortnox": "Fortnox",
    "fortnox_description": "fortnox_description",
    "Magic button": "Magisk knapp",
    "With one click - a quick and easy way to create important tasks. For example, a phone call from a client.": "Med ett klick - ett snabbt och enkelt sätt att skapa viktiga uppgifter. Till exempel ett telefonsamtal från en klient.",
    "With suppliers, you make your projects and partners management more efficient.": "Med leverantörer effektiviserar du din projekt- och partnerhantering.",
    "Powerful and flexible project management serves diverse use cases and workflows.": "Kraftfull och flexibel projektledning för olika användningsfall och arbetsflöden.",
    "client_portal_app_description": "client_portal_app_description",
    "Chat": "Chatt",
    "chat_app_description": "chat_app_description",
    "Companies House": "Företag Hus",
    "companies_house_app_description": "companies_house_app_description",
    "documents_app_description": "documents_app_description",
    "FreeAgent": "FreeAgent",
    "freeagent_description": "freeagent_description",
    "Trigon": "Trigon",
    "trigon_description": "trigon_description",
    "Connect and discover tools to help you manage your business.": "Anslut och upptäck verktyg som hjälper dig att hantera ditt företag.",
    "Subscribe now": "Prenumerera nu",
    "Compare plans": "Jämför olika paket",
    "Add company": "Lägg till företag",
    "BETA": "BETA",
    "Setup": "Setup",
    "Power up": "Sätta på",
    "Integrations": "Integrationer",
    "Hi! Do you want to work with a team and use extra features? No problem, first add your company!": "Hej! Vill du arbeta med ett team och använda extra funktioner? Inga problem, lägg först till ditt företag!",
    "Read more about Uku plans": "Läs mer om Uku-planer",
    "Contact role": "Kontakt roll",
    "Contact roles": "Kontakt roller",
    "Client groups": "Kundgrupper",
    "Client fields": "Klient fält",
    "Contact fields": "Fält för kontakter",
    "View archive": "Visa arkiv",
    "Restore from archive": "Återställa från arkiv",
    "Empty list": "Töm listan",
    "Task fields": "Aktivitets fält",
    "task topics": "Ämnen för uppgifter",
    "Keep the task opened when starting the timer": "Håll uppgiften öppen när du startar timern",
    "task templates": "Mallar för uppgifter",
    "Author": "Författare",
    "Duplicate": "Duplicera",
    "Uku task templates": "Uku uppgiftsmallar",
    "Are you sure that you want to delete this task template?": "Är du säker på att du vill ta bort den här uppgiftsmallen?",
    "Templates": "Mallar",
    "Overview": "Översikt",
    "chat_app_overview_text": "chat_app_overview_text",
    "Color": "Färg",
    "Are you sure to delete this field? You may lose the data.": "Är du säker på att du vill ta bort det här fältet? Du kan förlora data.",
    "Add field": "Lägg till fält",
    "Add section": "Lägg till sektion",
    "multiline": "Flera linjer",
    "Import": "Importera",
    "Import data": "Importera data",
    "Automate data collection with Smart Accounts": "Automatisera datainsamling med smarta konton",
    "<ul><li>Import purchase and sales entries, total entries and entry lines count;</li><li>Automate data collection with Smart Accounts;</li><li>Faster & more accurate billing through automated data exchange. Uku gathers information for preparing customers' invoices in one place and makes invoicing efficient.</li></ul>": "<ul><li>Importera inköps- och försäljningstransaktioner, totala transaktioner och antal transaktionsrader.</li><li>Automatisera datainsamling med smarta konton;</li><li>Snabbare och mer exakt fakturering genom automatiserat datautbyte. Uku samlar information för att förbereda kundernas fakturor på ett ställe och gör faktureringen effektiv.</li></ul>",
    "xero_app_overview_text": "xero_app_overview_text",
    "Import clients from {0}": "Importera klienter från {0}",
    "Before importing clients, you need to authorize with Xero and select the Company.": "Innan du importerar klienter måste du auktorisera med Xero och välja företag.",
    "Authorize Xero to start import": "Auktorisera Xero att starta importen",
    "Failed to import clients": "Det gick inte att importera klienter",
    "Failed to connect to WS": "Det gick inte att ansluta till WS",
    "emailing_app_overview_text": "emailing_app_overview_text",
    "Email signatures": "Email signatures",
    "Everyone": "Vem som helst",
    "Access": "Åtkomst",
    "Creator": "Skapare",
    "Are you sure you want to delete this signature? Some emails will be affected": "Are you sure you want to delete this signature? Some emails will be affected",
    "Email addresses": "E-postadresser",
    "Signatures": "Signatures",
    "Send emails": "Send emails",
    "Uku securely integrates with your email to help you manage and automate communication": "Uku integreras säkert med din e-post för att hjälpa dig att hantera och automatisera kommunikationen",
    "Use {0} address": "Använd {0} adress",
    "connect your email address": "Anslut din e-postadress",
    "Connect with Microsoft Exchange or other email server(SMTP)": "Anslut till Microsoft Exchange eller annan e-postserver (SMTP)",
    "Email integration reconnected": "E-postintegration återansluten",
    "Are you sure you want to delete this email integration?": "Är du säker på att du vill ta bort den här e-postintegrationen?",
    "Email templates": "E-postmallar",
    "Add email template": "Lägg till e-postmall",
    "Are you sure you want to save this template? Some tasks will be affected": "Är du säker på att du vill spara den här mallen? Vissa uppgifter kommer att påverkas",
    "Clients can leave task messages by replying to client portal email": "Clients can leave task messages by replying to client portal email",
    "Send a copy of client's response to member's inbox": "Send a copy of client's response to member's inbox",
    "Email recipients can leave task comments by replying to a task email": "Email recipients can leave task comments by replying to a task email",
    "economic_app_overview_text": "economic_app_overview_text",
    "Default layout": "Standard Layout",
    "Change agreement ID": "Ändra avtals-ID",
    "Failed to connect to server": "Misslyckades med att ansluta till servern",
    "Uku will import all clients, clients info and classificatiors. In the final step you can select which clients you want to add or update.": "Uku kommer att importera alla klienter, klientinformation och klassificerare. I det sista steget kan du välja vilka klienter du vill lägga till eller uppdatera.",
    "Connect e-conomic": "Anslut e-conomic",
    "Before importing clients, you need to connect Uku and economic software. To do this, create economic agreement and enter the agreement ID here.": "Innan du importerar klienter måste du ansluta Uku och ekonomisk programvara. Det gör du genom att skapa ett ekonomiskt avtal och ange avtals-ID här.",
    "Step {0}": "Steg {0}",
    "Get agreement ID": "Hämta avtals-ID",
    "Insert agreement ID": "Infoga avtals-ID",
    "Connect": "Anslut",
    "quickbooks_app_overview_text": "quickbooks_app_overview_text",
    "Uku will import all clients, clients info and classificatiors from QuickBooks. In the final step you can select which clients you want to add or update.": "Uku kommer att importera alla klienter, klientinformation och klassificerare från QuickBooks. I det sista steget kan du välja vilka klienter du vill lägga till eller uppdatera.",
    "Before importing clients, you need to connect with QuickBooks.": "Innan du importerar klienter måste du ansluta till QuickBooks.",
    "Connected to QuickBooks": "Ansluten till QuickBooks",
    "fortnox_app_overview_text": "fortnox_app_overview_text",
    "Uku will import all clients, clients info and classificators from Fortnox. In the final step you can select which clients you want to add or update.": "Uku kommer att importera alla klienter, klientinformation och klassificerare från Fortnox. I det sista steget kan du välja vilka klienter du vill lägga till eller uppdatera.",
    "Before importing clients, you need to connect with Fortnox.": "Innan du importerar klienter behöver du ansluta till Fortnox.",
    "Connect to Fortnox": "Anslut till Fortnox",
    "Connected to Fortnox": "Ansluten till Fortnox",
    "Delete template": "Ta bort mall",
    "Public": "Offentlig",
    "Workflow templates": "Mallar för arbetsflöden",
    "No workflow templates yet": "Inga arbetsflödesmallar ännu",
    "Modified": "Ändrad",
    "Uku workflow templates": "Mallar för Uku-arbetsflöde",
    "Are you sure you wish to delete this workflow?": "Är du säker på att du vill ta bort det här arbetsflödet?",
    "Project fields": "Fält för projekt",
    "Progress step": "Steg för förlopp",
    "Rename project": "Byt namn på projekt",
    "Project statuses": "Projektstatus",
    "You can use the statuses to restrict the workflow.": "Du kan använda statusarna för att begränsa arbetsflödet.",
    "Project phases": "Projektets faser",
    "Make your progress beautiful.": "Gör dina framsteg vackra.",
    "Permissions": "Behörigheter",
    "Users can manage workflow templates": "Användare kan hantera arbetsflödesmallar",
    "project_app_overview_text": "project_app_overview_text",
    "project_app_overview_description": "project_app_overview_description",
    "Configure summary task": "Konfigurera sammanfattningsaktivitet",
    "Uku will generate task with following title and topic on the last day of the month.": "Uku kommer att generera uppgift med följande titel och ämne den sista dagen i månaden.",
    "Task title": "Uppgiftsrubrik",
    "Recurrence": "Upprepning",
    "First import start date": "First import start date",
    "Count changes from previous periods": "Räkna ändringar från tidigare perioder",
    "If enabled, changes made to previous periods will be added to current month. If disabled, changes made to previous periods will not be accounted for.": "Om det här alternativet är aktiverat läggs ändringar som gjorts i tidigare perioder till i den aktuella månaden. Om den är inaktiverad kommer ändringar som gjorts i tidigare perioder inte att redovisas.",
    "Automatically finish summary tasks": "Automatically finish summary tasks",
    "If enabled, summary tasks will be created as finished.": "If enabled, summary tasks will be created as finished.",
    "Configure data fields": "Konfigurera datafält",
    "Select corresponding Uku field for each imported field. Same fields will be summarized. By leaving some field blank it will be ignored.": "Välj motsvarande Uku-fält för varje importerat fält. Samma fält kommer att summeras. Genom att lämna något fält tomt kommer det att ignoreras.",
    "New custom field": "Nytt anpassat fält",
    "Show more": "Visa mer",
    "Every month": "Varje månad",
    "Last work day of the month": "Last work day of the month",
    "Last day of the month": "Sista dagen i månaden",
    "1": "1",
    "2": "2",
    "3": "3",
    "4": "4",
    "5": "5",
    "6": "6",
    "7": "7",
    "8": "8",
    "9": "9",
    "10": "10",
    "11": "11",
    "12": "12",
    "13": "13",
    "14": "14",
    "15": "15",
    "16": "16",
    "17": "17",
    "18": "18",
    "19": "19",
    "20": "20",
    "21": "21",
    "22": "22",
    "23": "23",
    "24": "24",
    "25": "25",
    "26": "26",
    "27": "27",
    "28": "28",
    "Day {0} of next month": "Dag {0} i nästa månad",
    "Settings saved": "Inställningar sparade",
    "Uku will let you know when it is ready.": "Uku meddelar dig när den är klar.",
    "Reload data": "Ladda om data",
    "months": "månader",
    "This will overwrite existing summary tasks new values.": "Detta kommer att skriva över befintliga sammanfattningsaktiviteter nya värden.",
    "Overwrite": "Skriv över",
    "trigon_app_overview_text": "trigon_app_overview_text",
    "Uku will import all clients and their info from Trigon. In the final step you can select which clients you want to add or update.": "Uku will import all clients and their info from Trigon. In the final step you can select which clients you want to add or update.",
    "Connect Trigon": "Connect Trigon",
    "Before importing clients, you need to connect Uku and Trigon software. To do this, enter your credentials here.": "Before importing clients, you need to connect Uku and Trigon software. To do this, enter your credentials here.",
    "Insert email and password": "Insert email and password",
    "Automate your anti money laundering process": "Automatisera din process mot penningtvätt",
    "You are about to activate anti money laundering process. During that new additional fields will be added to your clients data and also system will start reminding you about updating them.<br><br>Additional fields are:<ul><li>Risk profile</il><li>Profile valid until</il><li>AML Staus</il><li>Document NO</il><li>Document valid until</li></ul>": "Du är på väg att aktivera processen för bekämpning av penningtvätt. Under det kommer nya ytterligare fält att läggas till i dina kunders data och även systemet kommer att börja påminna dig om att uppdatera dem.<br><br>Ytterligare fält är:<ul><li>Riskprofil<li>Profilen är giltig t.o.m.<li>AML Staus<li>Dokument nr<li>Dokumentet är giltigt t.o.m.</li></li></li></li></li></ul>",
    "You are about to activate anti money laundering process. During that new additional fields will be added to your clients data and also system will start reminding you about updating them.<br><br>Additional fields are:<ul><li>Risk profile</il><li>Next AML check</il><li>Pass/Fail</il><li>ID type</il><li>ID Number</il><li>Date of expiry</il><li>Additional checks</li></ul>": "Du är på väg att aktivera processen för bekämpning av penningtvätt. Under det kommer nya ytterligare fält att läggas till i dina kunders data och även systemet kommer att börja påminna dig om att uppdatera dem.<br><br>Ytterligare fält är:<ul><li>Riskprofil<li>Nästa AML-kontroll<li>Godkänd/underkänd<li>Typ av ID<li>ID-nummer<li>Sista giltighetsdag<li>Ytterligare kontroller</li></li></li></li></li></li></li></ul>",
    "Do not change client custom fields created by Uku": "Ändra inte klientanpassade fält som skapats av Uku",
    "day(s) before": "dag(ar) före",
    "Task name": "Arbetsuppgift",
    "Assigned": "Tilldelad",
    "Note": "Anteckning",
    "Manual run": "Manuell körning",
    "Create a task when the document expires": "Skapa en uppgift när dokumentet upphör att gälla",
    "Create a task when the risk profile must be updated": "Skapa en uppgift när riskprofilen måste uppdateras",
    "Flextime period": "Flextid",
    "Confirmation period": "Confirmation period",
    "Weekly": "Veckovis",
    "Add agreement": "Lägg till avtal",
    "flextime_app_overview_text": "flextime_app_overview_text",
    "supplier_app_overview_text": "supplier_app_overview_text",
    "supplier_app_overview_description": "supplier_app_overview_description",
    "Supplier type": "Typ av leverantör",
    "Parent type": "Överordnad typ",
    "Edit supplier type": "Redigera leverantörstyp",
    "New supplier type": "Ny leverantörstyp",
    "Are you sure you wish to delete this supplier type?": "Är du säker på att du vill ta bort den här leverantörstypen?",
    "Types": "Typer",
    "Supplier types": "Typer av leverantörer",
    "No supplier types yet": "Inga leverantörstyper ännu",
    "tripletex_app_overview_text": "tripletex_app_overview_text",
    "Uku will import all clients, clients info and classificators from Tripletex. In the final step you can select which clients you want to add or update.": "Uku kommer att importera alla klienter, klientinformation och klassificerare från Tripletex. I det sista steget kan du välja vilka klienter du vill lägga till eller uppdatera.",
    "Connect Tripletex": "Anslut Tripletex",
    "Before importing clients, you need to connect Uku and Tripletex software. To do this, create employee token and enter it here.": "Innan du importerar klienter måste du ansluta Uku- och Tripletex-programvara. Det gör du genom att skapa en personaltoken och ange den här.",
    "Get employee token": "Hämta personaltoken",
    "Insert employee token": "Infoga personaltoken",
    "Install": "Installera",
    "Open Chrome browser to install": "Öppna webbläsaren Chrome för att installera",
    "Works with your online accounting software.": "Fungerar med ditt bokföringsprogram online.",
    "New tasks can strike like lightning and that’s why Mini Uku is your best friend. No matter whether you’re making bank transfers or working in your accounting software; with Mini Uku you can add new tasks, track time and keep on top of all your notifications from any website.<br><br>Just one click on the owl icon provides an overview of your entire working day and helps you plan your schedule more efficiently.": "Nya uppgifter kan slå ner som blixten och det är därför Mini Uku är din bästa vän. Oavsett om du gör banköverföringar eller arbetar i ditt bokföringsprogram; med Mini Uku kan du lägga till nya uppgifter, spåra tid och hålla koll på alla dina aviseringar från vilken webbplats som helst.<br><br>Ett klick på uggleikonen ger en överblick över hela din arbetsdag och hjälper dig att planera ditt schema mer effektivt.",
    "merit_aktiva_app_overview_text_pl": "merit_aktiva_app_overview_text_pl",
    "merit_aktiva_app_overview_text": "merit_aktiva_app_overview_text",
    "Import clients": "Importera klienter",
    "documents_app_overview_text": "documents_app_overview_text",
    "Connect your existing document management system": "Connect your existing document management system",
    "Main folder": "Main folder",
    "Under this folder, Uku automatically creates folders for each client.": "Under this folder, Uku automatically creates folders for each client.",
    "You can customize each client folder separately under client settings.": "You can customize each client folder separately under client settings.",
    "Automatically create Public folder for client files and Private folder for member files": "Automatically create Public folder for client files and Private folder for member files",
    "Automatically create  Year / Month subfolder under each client for files sorting": "Automatically create  Year / Month subfolder under each client for files sorting",
    "Automatically create  Notes and Templates subfolders under each client for files sorting": "Automatically create  Notes and Templates subfolders under each client for files sorting",
    "Add task files added by Members": "Add task files added by Members",
    "Add task files added by Clients (from emails and client portal)": "Add task files added by Clients (from emails and client portal)",
    "Backup files to Uku file storage": "Backup files to Uku file storage",
    "Perfect example": "Perfect example",
    "Setup your SharePoint connection": "Setup your SharePoint connection",
    "Site URL": "Site URL",
    "Client ID": "Client ID",
    "Client secret": "Client secret",
    "Connection successful!": "Anslutningen lyckades!",
    "When disconnecting the service Uku will no longer be able to access the documents.": "When disconnecting the service Uku will no longer be able to access the documents.",
    "Google Drive": "Google Drive",
    "OneDrive": "OneDrive",
    "SharePoint": "SharePoint",
    "Select folder": "Select folder",
    "Manage": "Manage",
    "Refresh": "Uppdatera",
    "Be aware of the issues before they become problems": "Var medveten om problemen innan de blir problem",
    "<ul><li>Real time comparison of client contract and actual work done;</li><li>Be aware of the issues before they become problems;</li><li>Even with fixed prices you need to have internal measurements. Monitor the validity of the client’s agreement by comparing it with the actual amount of work done.</li></ul>": "<ul><li>Jämförelse i realtid av kundkontrakt och faktiskt utfört arbete;</li><li>Var medveten om problemen innan de blir problem;</li><li>Även med fasta priser behöver du ha interna mått. Övervaka giltigheten av kundens avtal genom att jämföra det med den faktiska mängden arbete som utförts.</li></ul>",
    "client_portal_app_overview_text": "client_portal_app_overview_text",
    "Branding": "Varumärke",
    "Subdomain": "Underdomän",
    "Default language": "Standardspråk",
    "Client portal URL in other languages": "Klientportalens URL på andra språk",
    "Copy URL": "Kopiera webbadress",
    "Trademark": "Varumärke",
    "Default signature": "Default signature",
    "Trademark text color": "Varumärkestextfärg",
    "Choose color": "Välj färg",
    "Brand background color": "Varumärkets bakgrundsfärg",
    "Logo": "Logotyp",
    "Max. dimensions 180 x 60 px": "Max. mått 180 x 60 px",
    "Favicon": "Favicon",
    "Delete icon": "Ikonen Ta bort",
    "Upload icon file": "Ladda upp ikonfil",
    "Recommended size 260 x 260 px": "Rekommenderad storlek 260 x 260 px",
    "Company description": "Beskrivning av företaget",
    "Displayed on the login page.": "Visas på inloggningssidan.",
    "Describe here what services you offer and how you help your clients.": "Beskriv här vilka tjänster du erbjuder och hur du hjälper dina kunder.",
    "Welcome video": "Välkomstvideo",
    "Displayed on the login page when your client contact enters for the first time": "Visas på inloggningssidan när din kundkontakt går in för första gången",
    "Use Uku video": "Använda Uku-video",
    "View": "Visa",
    "Use other video": "Använd annan video",
    "Youtube or Vimeo video URL": "Webbadress till Youtube- eller Vimeo-video",
    "Show file upload box for client tasks": "Visa filuppladdningsruta för klientuppgifter",
    "Invalid data": "Ogiltig data",
    "Client portal preview": "Förhandsversion av klientportalen",
    "Client portal URL for {0} copied to clipboard": "Klientportal-URL för {0} kopieras till Urklipp",
    "Personalize your client portal's menu": "Personalize your client portal's menu",
    "Menu links saved": "Menu links saved",
    "Add custom links to essential items such as: Documents, Financial reports, Onboarding forms, Feedback surveys, Service agreements, Pricing, Instructions, Invoices. This section allows you to build the menu structure, set the order of items, and define default links. You can also customize names and links for each client individually. Only menus with defined links are displayed in client portal. <a href='/api/help_link/cp_menu_links' target='_blank'>Read more ›</a>": "Add custom links to essential items such as: Documents, Financial reports, Onboarding forms, Feedback surveys, Service agreements, Pricing, Instructions, Invoices. This section allows you to build the menu structure, set the order of items, and define default links. You can also customize names and links for each client individually. Only menus with defined links are displayed in client portal. <a href='/api/help_link/cp_menu_links' target='_blank'>Read more ›</a>",
    "Menu links": "Menu links",
    "Uku will import all clients from FreeAgent. In the final step you can select which clients you want to add or update.": "Uku will import all clients from FreeAgent. In the final step you can select which clients you want to add or update.",
    "Before importing clients, you need to connect with FreeAgent.": "Before importing clients, you need to connect with FreeAgent.",
    "Connect to FreeAgent": "Connect to FreeAgent",
    "Connected to FreeAgent": "Connected to FreeAgent",
    "freeagent_app_overview_text": "freeagent_app_overview_text",
    "Add recurring task": "Lägg till återkommande uppgift",
    "Reminder tasks updated": "Påminnelseuppgifter uppdaterade",
    "Create recurring tasks for Companies House clients.": "Skapa återkommande uppgifter för Companies House-kunder.",
    "companies_house_app_overview_text": "companies_house_app_overview_text",
    "buttons": "Knappar",
    "Show to me": "Visa för mig",
    "magic_button_app_overview_text": "magic_button_app_overview_text",
    "Buttons": "Knappar",
    "Member rights": "Medlemmarnas rättigheter",
    "Allow managers to view and create their client contracts and invoices": "Tillåt chefer att visa och skapa sina kundkontrakt och fakturor",
    "Allow members to view and create their client invoices": "Tillåt medlemmar att se och skapa sina kundfakturor",
    "Allow members to view their client invoices": "Tillåt medlemmar att se sina kundfakturor",
    "Allow only owners to add and update products": "Tillåt endast ägare att lägga till och uppdatera produkter",
    "Allow members to send invoices to clients": "Allow members to send invoices to clients",
    "Allow members to confirm their client invoice rows": "Tillåt medlemmar att bekräfta sina kundfakturarader",
    "Send PDF invoice": "Skicka PDF-faktura",
    "Send invoice copy": "Send invoice copy",
    "Default rounding": "Standardavrundning",
    "Round all times up to x": "Avrunda alla gånger uppåt till x",
    "Time rounding increment": "Ökning av tidsavrundning",
    "Apply time rounding to": "Tillämpa tidsavrundning på",
    "Default configuration": "Standardkonfiguration",
    "Invoice date": "Fakturadatum",
    "Invoice entry date": "Datum för fakturaregistrering",
    "Bill tracked time by": "Räkningen spåras tid efter",
    "Bill task field by": "Fakturera aktivitetsfält efter",
    "Create one invoice merging invoices from the same period": "Skapa en faktura som slår samman fakturor från samma period",
    "Invoices from the same period": "Fakturor från samma period",
    "Hide zero sum lines": "Dölj nollsummelinjer",
    "By default, time entry is billable": "Som standard är tidsposten fakturerbar",
    "Invoice number": "Fakturanummer",
    "Prefix": "Prefix",
    "Suffix": "Suffix",
    "Google Gmail": "Google Gmail",
    "Microsoft Outlook": "Microsoft Outlook",
    "Billing settings saved": "Faktureringsinställningar sparade",
    "billing_app_overview_text": "billing_app_overview_text",
    "Products": "Produkter",
    "Contract templates": "Mallar för avtal",
    "Invoice templates": "Mallar för fakturor",
    "Tools": "Verktyg",
    "Replace tax": "Ersätt skatt",
    "Old tax": "Gammal skatt",
    "New tax": "Ny skatt",
    "Find tax": "Hitta skatt",
    "Replace VAT in products": "Ersätt moms på produkter",
    "Replace VAT in master contracts": "Ersätt moms i ramavtal",
    "Replace VAT in client contracts & draft invoices": "Ersätt moms i kundkontrakt och fakturautkast",
    "Replace VAT values": "Ersätt momsvärden",
    "This action cannot be undone": "Är du säker på att du vill återställa allt till standardalternativ? Detta kan inte göras ogjort",
    "Replace": "Ersätt",
    "Result": "Resultat",
    "PDF templates": "PDF-mallar",
    "E-mail templates": "Mallar för e-post",
    "Edit PDF template": "Redigera PDF-mall",
    "Import classificators": "Importera klassificerare",
    "products": "produkter",
    "product": "produkt",
    "Product / service": "Produkt / tjänst",
    "Calculate": "Beräkna",
    "Article": "Artikel",
    "Resource": "Resurs",
    "Cost center": "Kostnadsställe",
    "Taxes": "Moms",
    "Code": "Kod",
    "Source": "Källa",
    "Articles": "Artiklar",
    "Resources": "Resurser",
    "Cost centers": "Kostnadsställen",
    "Units": "Enheter",
    "Unit": "Enhet",
    "Bank accounts": "Bankkonton",
    "Bank account": "Bankkonto",
    "Bank name": "Bankens namn",
    "SWIFT code": "SWITFT-kod",
    "VAT number": "VAT-nummer",
    "Do you wish to import only new data or also overwrite existing?": "Vill du bara importera nya data eller även skriva över befintliga?",
    "Only new": "Endast nytt",
    "New items will be added. Existing ones will remain unchanged by import.": "Nya objekt kommer att läggas till. Befintliga kommer att förbli oförändrade vid import.",
    "Import everything": "Importera allt",
    "Connect accounting service": "Anslut redovisningstjänst",
    "Service": "Tjänst",
    "API ID": "API ID",
    "API key": "API-nyckel",
    "Company Account Id": "Företagskonto-ID",
    "Api secret": "API-hemlighet",
    "E-conomic": "E-conomic",
    "SmartAccounts": "SmartAccounts (på engelska)",
    "Test": "Test",
    "Lock time entries": "Lås tidsposter",
    "Owner rights": "Ägarens rättigheter",
    "Disable company settings edit for all members": "Inaktivera redigering av företagsinställningar för alla medlemmar",
    "Disable personal clients for members": "Inaktivera personliga klienter för medlemmar",
    "Show member birthdays": "Visa medlemmars födelsedagar",
    "Show contact birthdays": "Visa kontaktfödelsedagar",
    "Weekly @ Sun {0}": "Varje vecka @ Sön {0}",
    "Monthly @ last day of month": "Månadsvis @ sista dagen i månaden",
    "Company event list": "Lista över företagshändelser",
    "How long?": "Hur länge?",
    "Invoice no.": "Faktura nr.",
    "Login options": "Loginalternativ",
    "Tenant ID (optional)": "Klientorganisations-ID (valfritt)",
    "Add Active Directory tenant ID, if only users belonging to this tenant are allowed to connect": "Lägg till Active Directory-klientorganisations-ID, om endast användare som tillhör den här klientorganisationen tillåts ansluta",
    "How to find ID’s?": "Hur hittar man ID-handlingar?",
    "Microsoft connected": "Microsoft ansluten",
    "Google connected": "Google ansluten",
    "Edit company": "Redigera företag",
    "Timezone": "Tidszon",
    "Invoice email": "Faktura epost",
    "Subscription plan": "Månadsgivande",
    "Payment failed": "Betalningen misslyckades",
    "Retry payment": "Försök att betala igen",
    "Next payment": "Nästa betalning",
    "Update payment method": "Uppdatera betalningsmetod",
    "Plan": "Plan",
    "Choose a plan": "Välj ett paket",
    "Change plan": "Ändra plan",
    "{0}-day free trial until {1}": "{0} dagars gratis provperiod fram till {1}",
    "monthly": "månadsvis",
    "yearly": "årsvis",
    "{0} member": "{0} ledamot",
    "{0} members": "{0} medlemmar",
    "{0} plan": "{0} plan",
    "Cancelled (valid until {0})": "Inställd (giltig t.o.m. {0})",
    "Your trial expired on {0}": "Utvärderingsversionen upphörde att gälla {0}",
    "Your subscription expired on {0}": "Din prenumeration gick ut den {0}",
    "It’s nice to see you! If you'd like to get up and running with a Uku subscription, click Choose a plan": "Det är trevligt att se dig! Om du vill komma igång med en Uku-prenumeration klickar du på Välj ett abonnemang",
    "Save {0} by paying for a year!": "Spara {0} genom att betala för ett år!",
    "Choose plan": "Välj plan",
    "Pay annually": "Betala årligen",
    "Instructions sent!": "Instruktioner skickade!",
    "Instructions for resetting your password have been sent to": "Instruktioner för att återställa ditt lösenord har skickats till",
    "You’ll receive this email within 5 minutes. Be sure to check your spam folder, too.": "Du får det här e-postmeddelandet inom 5 minuter. Var noga med att kontrollera din skräppostmapp också.",
    "Back to login page": "Tillbaka till inloggningssidan",
    "Get new password": "Skaffa nytt lösenord",
    "Pick a password": "Välj ett lösenord",
    "Use minimum 8 characters with letters & numbers": "Använd minst 8 tecken med bokstäver och siffror",
    "Create your Uku Account": "Skapa ditt Uku-konto",
    "Connect your Xero Account": "Anslut ditt Xero-konto",
    "Phone": "Telefon",
    "I agree to the": "Jag godkänner",
    "Terms of Service": "Användarvillkor",
    "Next": "Nästa",
    "Having trouble?": "Har problem?",
    "We can help": "Vi kan hjälpa till",
    "Log in instead": "Logga in istället",
    "You are invited to join": "Du är inbjuden att gå med",
    "Accept invitation": "Acceptera inbjudan",
    "Check your email": "Kolla din e-post",
    "I sent you an email with a link to activate your account. This is important to ensure the security of your account.": "Jag har skickat ett e-postmeddelande till dig med en länk för att aktivera ditt konto. Detta är viktigt för att säkerställa säkerheten för ditt konto.",
    "Go to": "Gå till",
    "Need a new password?": "Behöver du ett nytt lösenord?",
    "Enter your e-mail address and we will send you directions for changing your password": "Ange din e-postadress så skickar vi dig en vägbeskrivning för att ändra ditt lösenord",
    "Send me instructions": "Skicka mig instruktioner",
    "Never mind, go back": "Strunt samma, gå tillbaka",
    "No login options enabled. Please contact the company owner": "Inga inloggningsalternativ aktiverade. Kontakta företagets ägare",
    "Log in to Uku": "Logga in på Uku",
    "Forgot password?": "Glömt lösenord?",
    "Don't have account?": "Har du inget konto?",
    "Create account": "Skapa ett konto",
    "No. 1 tool for accounting practices. Automated workflows, time tracking, reports, monitoring, CRM. Get work done on time & profitably. Try for free!": "Verktyg nr 1 för redovisningspraxis. Automatiserade arbetsflöden, tidrapportering, rapporter, övervakning, CRM. Få jobbet gjort i tid och på ett lönsamt sätt. Prova gratis!",
    "Total items:": "Totalt antal poster:",
    "Add new": "Lägg till ny",
    "Amount": "Belopp",
    "Account created range": "Intervall för skapat konto",
    "Usage limit": "Användningsgräns",
    "Valid until": "Giltig till",
    "Edit help link": "Redigera hjälplänk",
    "New help link": "Ny hjälplänk",
    "Name key": "Namn nyckel",
    "Country code": "Landskod",
    "Period (months)": "Period (månader)",
    "Account created from": "Konto skapat från",
    "Account created until": "Kontot skapades fram till",
    "Used count": "Antal använda",
    "Free days": "Free days",
    "Sum": "Summa",
    "Create voucher": "Skapa verifikation",
    "Edit voucher": "Redigera verifikation",
    "Are you sure to delete this voucher?": "Är du säker på att du vill ta bort den här kupongen?",
    "row | rows": "rad | rader",
    "Add event": "Lägg till händelse",
    "Are you sure you wish to delete this event?": "Är du säker på att du vill ta bort den här händelsen?",
    "event | events": "Evenemang | evenemang",
    "Security object id": "ID för säkerhetsobjekt",
    "Direct rights": "Direkta rättigheter",
    "Computed rights": "Beräknade rättigheter",
    "Add link": "Lägg till länk",
    "Are you sure you wish to delete this entry?": "Är du säker på att du vill ta bort den här posten?",
    "link | links": "länk | Länkar",
    "Event type": "Evenemangstyp",
    "Date from": "Från datum",
    "Date until": "Datum till",
    "Shortened by h": "Förkortas med h",
    "Category": "Kategori",
    "demo | demos": "Demo | Demos",
    "Created at": "Created at",
    "Invited by": "Invited by",
    "referral | referrals": "referral | referrals",
    "Companies": "Företag",
    "Leads": "Leads",
    "Demos": "Demos",
    "Vouchers": "Kuponger",
    "KPI": "KPI",
    "Referrals": "Referrals",
    "Activity log": "Aktivitets logg",
    "Notifications": "Aviseringar",
    "Me": "Mig",
    "Important notifications will appear here.": "Viktiga meddelanden kommer att visas här.",
    "Back": "Tillbaka",
    "Return to UKU": "Återgå till UKU",
    "Choose plan for {0}": "Välj abonnemang för {0}",
    "First payment will be made after the end of the trial period.": "Första utbetalning kommer att göras efter provperiodens slut.",
    "Members and subscription can always be changed.": "Medlemmar och abonnemang kan alltid ändras.",
    "Your subscription is externally managed by Xero": "Your subscription is externally managed by Xero",
    "Select plan": "Select plan",
    "Billing period": "Faktureringsperiod",
    "Compare features": "Jämför funktioner",
    "Cancel uku subscription": "Avbryt uku-prenumeration",
    "{0} discount": "{0} rabatt",
    "You have currently<br />{0} active member": "Du har för närvarande<br />{0} Aktiv medlem",
    "You have currently<br />{0} active members": "Du har för närvarande<br />{0} Aktiva medlemmar",
    "Select yearly plan": "Välj årsplan",
    "Select monthly plan": "Välj månadsplan",
    "Attention!": "Obs!",
    "Plan change request": "Plan change request",
    "If you want to use Uku for free then deactivate your account and continue with {0} plan": "Om du vill använda Uku gratis, inaktivera ditt konto och fortsätt med {0} plan",
    "per member/month (billed yearly)": "per medlem/månad (faktureras årligen)",
    "or {0} per member/month (monthly)": "eller {0} per medlem/månad (månadsvis)",
    "Everything in {0}, plus:": "Allt i {0}, plus:",
    "Compare plans, feature-by-feature": "Jämför abonnemang, funktion för funktion",
    "Deactivate account": "Inaktivera konto",
    "Are you sure to deactivate {0} account?": "Är du säker på att du vill inaktivera {0} konto?",
    "If you choose to continue with freelancer plan your company account will be deactivated. Data that is related to this company will be removed.": "Om du väljer att fortsätta med frilansarplanen kommer ditt företagskonto att inaktiveras. Uppgifter som är relaterade till detta företag kommer att tas bort.",
    "Deactivate": "Avaktivera",
    "Teamwork": "Grupparbete",
    "Unlimited clients + import": "Obegränsat antal klienter + import",
    "Access management": "Hantering av inloggning",
    "Custom fields": "Anpassade fält",
    "Live chat support": "Support via livechatt",
    "AML": "AML",
    "API": "API",
    "Client Portal": "Kundportal",
    "New!": "Nyhet!",
    "Custom integrations": "Anpassade integrationer",
    "Assisted clients import": "Import av assisterade klienter",
    "Tailor-made team workshop": "Skräddarsydd teamverkstad",
    "Early access to features": "Tidig tillgång till funktioner",
    "Pay by invoice": "Betala med faktura",
    "Dedicated account manager": "Dedikerad kontoansvarig",
    "Hi! Your trial is over. Please choose {0} subscription plan to continue work": "Hej! Din provperiod är över. Välj {0} prenumerationsplan för att fortsätta arbeta",
    "Hi! You need to upgrade {0} subscription plan to use that feature": "Hej! Du måste uppgradera {0} prenumerationsplan för att kunna använda den funktionen",
    "Waiting for the subscription to complete": "Waiting for the subscription to complete",
    "VAT": "Moms",
    "This is subscription period amount.": "Detta är teckningsperiodens belopp.",
    "You save yearly {0}": "Du sparar årligen {0}",
    "Add voucher": "Lägg till verifikation",
    "Existing credit": "Befintlig kredit",
    "Current payment": "Aktuell betalning",
    "This is the current payment amount. Your bank also requires confirmation for the subscription period amount.": "Detta är det aktuella betalningsbeloppet. Din bank kräver också en bekräftelse på teckningsperiodens belopp.",
    "Confirm subscription {0}": "Bekräfta prenumerationen {0}",
    "Your subscription will renew on": "Din prenumeration förnyas den",
    "Thank you for believing in us!": "Tack för att du tror på oss!",
    "Uku team": "Uku-teamet",
    "Voucher {1} (-{0}%)": "Kupong {1} (-{0}%)",
    "Voucher {0}": "Kupong {0}",
    "New plan": "Ny plan",
    "Changed plan": "Ändrad plan",
    "Add {0} member": "Lägg till {0} medlem",
    "Add {0} members": "Lägg till {0} medlemmar",
    "Remove {0} member": "Ta bort {0} medlem",
    "Remove {0} members": "Ta bort {0} medlemmar",
    "No changes to plan": "Inga ändringar i planen",
    "Discount -{0}% with Yearly subscription": "Rabatt -{0}% med årsprenumeration",
    "Yearly discounted price (-{0}%)": "Rabatterat pris per år (-{0}%)",
    "Subscription updated": "Prenumerationen uppdaterad",
    "Please wait": "Vänligen vänta",
    "Your payment failed": "Din betalning misslyckades",
    "Please check that you entered the data correctly or use another card": "Kontrollera att du har angett uppgifterna korrekt eller använd ett annat kort",
    "Try again": "Försök igen",
    "Pay": "Betala",
    "Payment": "Betalning",
    "Payment method updated": "Betalningsmetod uppdaterad",
    "Edit member": "Ändra medlem",
    "First name": "Förnamn",
    "Last name": "Efternamn",
    "External ID": "Externt ID",
    "Select groups": "Välj grupper",
    "Administrator": "Administratör",
    "Activate member": "Aktivera medlem",
    "Deactivate member": "Inaktivera medlem",
    "Paid member": "Belönad medlem",
    "Send an invitation": "Skicka en inbjudan",
    "Limited": "Begränsad",
    "No invite, no access": "Ingen inbjudan, ingen åtkomst",
    "Free until activated": "Gratis tills den aktiveras",
    "No access, no charge": "Ingen åtkomst, ingen avgift",
    "Hidden member": "Dold medlem",
    "Edit members": "Redigera medlemmar",
    "Select user": "Välj användare",
    "Member will be assigned to every selected client": "Medlem kommer att tilldelas varje vald kund",
    "Member will be removed from all selected clients": "Medlemmen kommer att tas bort från alla valda klienter",
    "Assign user": "Tilldela användare",
    "Set as primary user": "Ange som primär användare",
    "Added as a default user when adding a task plan": "Läggs till som standardanvändare när du lägger till en uppgiftsplan",
    "Remove from new tasks": "Ta bort från nya uppgifter",
    "Remove from plan tasks": "Ta bort från planuppgifter",
    "Remove": "Ta bort",
    "Admin": "Admin",
    "Remove user": "Ta bort användare",
    "Assign to incomplete tasks": "Tilldela till ofullständiga uppgifter",
    "Reassign incomplete tasks": "Tilldela om ofullständiga uppgifter",
    "Assign to plan tasks": "Tilldela till planeringsuppgifter",
    "Reassign plan tasks": "Tilldela om planuppgifter",
    "Owner will be assigned to tasks if the removed user was the last assigned user.": "Ägaren tilldelas uppgifter om den borttagna användaren var den senast tilldelade användaren.",
    "Run integration": "Kör integrering",
    "Run": "Kör",
    "Integration configuration": "Konfiguration av integrering",
    "Read the manual": "Läs manualen",
    "Api key": "API-nyckel",
    "Are you sure to delete this integration info?": "Är du säker på att du vill ta bort den här integreringsinformationen?",
    "Edit Contracts": "Redigera kontrakt",
    "Replace following contracts": "Ersätt följande avtal",
    "Append services to following contracts": "Komplettera med tjänster i följande avtal",
    "Choose template": "Välj mall",
    "Append only": "Lägg endast till",
    "with template": "med mall",
    "All existing contracts": "Alla befintliga kontrakt",
    "All quarterly contracts": "Alla kvartalskontrakt",
    "All monthly contracts": "Alla månadskontrakt",
    "All yearly contracts": "Alla årskontrakt",
    "Next invoice number": "Nästa fakturanummer",
    "Number is too big, it cannot exceed 15 digits": "Numret är för stort, det får inte överstiga 15 siffror",
    "Replace topic": "Ersätt ämne",
    "All tasks and plans with current topic will be replaced with the new selected topic.": "Alla uppgifter och planer med aktuellt ämne kommer att ersättas med det nya valda ämnet.",
    "Topics replaced": "Ämnen som ersatts",
    "All tasks with the topic `{0}` will be replaced with `{1}`. This is not reversible. Are you sure?": "Alla uppgifter med ämnet \"{0}\" kommer att ersättas med \"{1}\". Detta är inte reversibelt. Är du säker?",
    "Name of topic": "Ämnets namn",
    "New time entries will be marked as non-billable": "New time entries will be marked as non-billable",
    "Change topic": "Ändra ämne",
    "Add new topic": "Lägg till nytt ämne",
    "This topic is in use. Do you wish to archive it?": "Det här ämnet används. Vill du arkivera den?",
    "Are you sure that you want to delete this topic?": "Är du säker på att du vill ta bort det här ämnet?",
    "These items will be deleted permanently": "Dessa objekt kommer att raderas permanent",
    "Are you sure that you want to delete this client group?": "Är du säker på att du vill ta bort den här klientgruppen?",
    "This client group is in use. Do you wish to archive it?": "Den här klientgruppen används. Vill du arkivera den?",
    "Edit client group": "Redigera klientgrupp",
    "New client group": "Ny kundgrupp",
    "Price": "Pris",
    "Quantity": "Antal",
    "Unit will be translated to client language": "Enheten kommer att översättas till kundens språk",
    "Pick date & time": "Välj ett datum och se lediga tider",
    "Share equally": "Dela lika",
    "Change existing": "Ändra befintlig",
    "Choose bookmark": "Välj bokmärke",
    "New title": "Ny rubrik",
    "Set as my default view": "Ange som standardvy",
    "Signature name": "Signature name",
    "Layout": "Layout",
    "Top": "Top",
    "Middle": "Middle",
    "Bottom": "Bottom",
    "Logo left": "Logo left",
    "Logo top": "Logo top",
    "No logo": "No logo",
    "Linkedin": "Linkedin",
    "Facebook": "Facebook",
    "Email signature": "Email signature",
    "Edit email signature": "Edit email signature",
    "Add email signature": "Add email signature",
    "Font color": "Font color",
    "Actions": "Åtgärder",
    "Delete signature": "Delete signature",
    "Do you wish to update related contracts and invoices?": "Vill du uppdatera relaterade avtal och fakturor?",
    "Update contract templates, active contracts and open invoices.": "Uppdatera avtalsmallar, aktiva avtal och öppna fakturor.",
    "The following fields will be updated": "Följande fält kommer att uppdateras",
    "Custom Value": "Anpassat värde",
    "This product is in use. Do you wish to archive it?": "Denna produkt är i bruk. Vill du arkivera den?",
    "Are you sure that you want to delete this product?": "Är du säker på att du vill ta bort den här produkten?",
    "Customize for client": "Anpassa för klient",
    "Customize for template": "Anpassa för mall",
    "Open product template": "Öppna produktmall",
    "Create product template": "Skapa produktmall",
    "Master template": "Huvudmall",
    "Client product": "Kundens produkt",
    "Client product / service": "Kundens produkt/tjänst",
    "New client product": "Ny kundprodukt",
    "Template product": "Mall för produkt",
    "Template product / service": "Mall produkt/tjänst",
    "New template product": "Ny mallprodukt",
    "Edit translations": "Redigera översättningar",
    "Billable topics": "Fakturerbara ämnen",
    "Billable time": "Fakturerbar tid",
    "Minimum quantity": "Minsta kvantitet",
    "Minimum time": "Minsta tid",
    "Integration parameters": "Parametrar för integrering",
    "Empty values will use product default": "Tomma värden kommer att använda produktens standard",
    "Pricing": "Priser",
    "DC %": "Rab. %",
    "Sum all matching rows": "Summera alla matchande rader",
    "When enabled, total price is a cumulative sum of all matching rows. By default, total price price only uses the highest matching row.": "När det här alternativet är aktiverat är totalpriset en kumulativ summa av alla matchande rader. Som standard använder det totala priset endast den rad som matchar mest.",
    "Prices since": "Priser sedan",
    "Add price": "Lägg till pris",
    "Add pricing period": "Lägg till prissättningsperiod",
    "Update contracts": "Uppdatera kontrakt",
    "(Without topic)": "(Utan ämne)",
    "Fixed price": "Fast pris",
    "Product": "Produkt",
    "Event created": "Evenemanget skapades",
    "Project created": "Tjänst skapad",
    "Event deleted": "Evenemang raderat",
    "Project deleted": "Projektet har tagits bort",
    "Workflow added": "Arbetsflöde har lagts till",
    "Workflow removed": "Arbetsflödet har tagits bort",
    "Workflow updated": "Arbetsflödet har uppdaterats",
    "Event cancelled": "Evenemanget inställt",
    "Project cancelled": "Projektet avbröts",
    "Event reactivated": "Händelsen återaktiverad",
    "Project reactivated": "Projektet återaktiveras",
    "Event archived": "Händelsen arkiverad",
    "Project archived": "Arkiverat projekt",
    "Event unarchived": "Händelsen är inte arkiverad",
    "Project unarchived": "Projekt som inte arkiveras",
    "Event changed": "Händelsen har ändrats",
    "Project changed": "Projektet har ändrats",
    "Event status changed: {0}": "Händelsestatus har ändrats: {0}",
    "Project status changed: {0}": "Projektets status har ändrats: {0}",
    "Event status changed": "Händelsestatus har ändrats",
    "Project status changed": "Projektstatus har ändrats",
    "Task created": "Uppgiften har skapats",
    "Task changed": "Uppgiften har ändrats",
    "Task finished": "Uppgiften slutförd",
    "Task not finished": "Uppgiften har inte slutförts",
    "Task deleted": "Uppgiften har tagits bort",
    "Add project": "Lägg till projekt",
    "Hide filters": "Dölj filter",
    "Show filters": "Visa filter",
    "Cancel event": "Avbryt evenemang",
    "Cancel project": "Avbryt projekt",
    "Manage event fields": "Hantera händelsefält",
    "Manage project fields": "Hantera projektfält",
    "New event": "Nytt evenemang",
    "New project": "Nytt projekt",
    "{0} (Copy)": "{0} (kopiera)",
    "Are you sure you wish to delete this project?": "Är du säker på att du vill ta bort det här projektet?",
    "Are you sure to archive this event?": "Är du säker på att arkivera den här händelsen?",
    "Are you sure to archive this project?": "Är du säker på att arkivera det här projektet?",
    "Are you sure to cancel this event?": "Är du säker på att ställa in det här evenemanget?",
    "Are you sure to cancel this project?": "Är du säker på att du kommer att avbryta det här projektet?",
    "Communication": "Communication",
    "Log": "Logg",
    "Create event workflow": "Skapa händelsearbetsflöde",
    "Create project workflow": "Skapa projektarbetsflöde",
    "Use workflow templates to set up tasks effectively or": "Använd arbetsflödesmallar för att ställa in uppgifter effektivt eller",
    "Add tasks manually": "Lägga till uppgifter manuellt",
    "Save bookmark": "Spara bokmärke",
    "Remove filters": "Ta bort filter",
    "Filter": "Filtrera",
    "Show multiselect": "Visa flerval",
    "To do today": "Att göra idag",
    "This and next month": "Den här och nästa månad",
    "Last 3 months": "Senaste 3 månaderna",
    "Next 3 months": "Kommande 3 månader",
    "Starts": "Startar",
    "To do": "Att göra",
    "today": "idag",
    "tomorrow": "imorgon",
    "yesterday": "igår",
    "Previous week": "Föregående vecka",
    "Group similar tasks": "Gruppera liknande uppgifter",
    "Group by client": "Gruppera efter klient",
    "Group by date": "Gruppera efter datum",
    "Group by topic": "Gruppera efter ämne",
    "Are you sure to remove google?": "Är du säker på att ta bort Google?",
    "Google log in": "Google-inloggning",
    "Microsoft log in": "Microsoft-inloggning",
    "Are you sure to remove microsoft?": "Är du säker på att ta bort microsoft?",
    "Are you want to disconnect Xero?": "Are you want to disconnect Xero?",
    "Reset password": "Reset password",
    "Your details": "Dina uppgifter",
    "City": "Stad",
    "Regional format": "Regionalt format",
    "Default company": "Förvalt företag",
    "Lock time entries notification": "Meddelande om låsning av tidsangivelser",
    "Notify by": "Anmäl senast",
    "Delete my account": "Ta bort mitt konto",
    "Attention": "Obs",
    "Are you sure that you want to delete your account?": "Är du säker på att du vill ta bort ditt konto?",
    "Notification": "Notifikation",
    "Notification & email": "Meddelande och e-post",
    "Vacations / absence": "Semester/frånvaro",
    "Edit balance": "Redigera saldo",
    "View history": "Visa historik",
    "Request": "Förfrågan",
    "How long": "Hur länge",
    "Requested": "Begärda",
    "Approved": "Godkänd",
    "Rejected": "Nekad",
    "In review": "I granskning",
    "Change": "Ändra",
    "Agreements": "Avtal",
    "New agreement": "Nytt avtal",
    "Change agreement": "Ändra avtal",
    "Stop demo": "Stoppa demo",
    "Show": "Visa",
    "Don't show": "Visa inte",
    "Don't send": "Skicka inte",
    "Email workdays at 7 AM": "E-posta vardagar kl. 7",
    "Email at 3 PM": "E-post kl. 15",
    "Email at once": "E-post på en gång",
    "Email Sundays at 11 PM": "E-post söndagar kl. 23",
    "First day of the month": "Första dagen i månaden",
    "to email": "till e-post",
    "E-mail at once": "E-posta på en gång",
    "System": "System",
    "Person": "Person",
    "Picture": "Bild",
    "Time zone": "Tidszon",
    "Calendar settings": "Inställningar för kalendern",
    "Public holidays": "Helgdagar",
    "Tax deadlines": "Tidsfrister för beskattning",
    "News": "Nyheter",
    "External services": "Externa tjänster",
    "Agreement": "Avtal",
    "Active agreement": "Aktiv avtal",
    "Weekly hours": "Öppettider per vecka",
    "Edit supplier": "Redigera leverantör",
    "New supplier": "Ny leverantör",
    "Are you sure you wish to delete this supplier?": "Är du säker på att du vill ta bort den här leverantören?",
    "Add supplier": "Lägg till leverantör",
    "Supplier types are not defined. Please go to the suppliers app settings to add.": "Leverantörstyper är inte definierade. Gå till leverantörens appinställningar för att lägga till.",
    "No members yet": "Inga medlemmar ännu",
    "Edit group": "Ändra grupp",
    "Add group": "Lägg till grupp",
    "Are you sure to delete this user group?": "Är du säker på att du vill ta bort den här användargruppen?",
    "Get set up to work with team": "Kom igång med att arbeta med teamet",
    "Company account allows you to use tools for teams, get deeper insights etc. Raise the quality of your team's workflow and lead a more profitable business.": "Med företagskonto kan du använda verktyg för team, få djupare insikter etc. Höj kvaliteten på teamets arbetsflöde och led en mer lönsam verksamhet.",
    "Create company account": "Skapa företagskonto",
    "By creating a company account you activate Uku free subscription for {0} days.": "Genom att skapa ett företagskonto aktiverar du Uku gratis prenumeration i {0} dagar.",
    "You have invited {0}/{1} members": "Du har bjudit in {0}/{1} medlemmar",
    "Upgrade": "Uppgradera",
    "View profile": "Visa profil",
    "To add members to your team, you'll need to create a company account": "Om du vill lägga till medlemmar i ditt team måste du skapa ett företagskonto",
    "Export": "Exportera",
    "Re-invite sent": "Inbjudan på nytt har skickats",
    "View report": "Visa rapport",
    "Member {0} will be deactivated.": "Medlemmens {0} kommer att inaktiveras.",
    "Please select new member who will replace {0}.": "Välj ny medlem som ska ersätta {0}.",
    "Select new member": "Välj ny medlem",
    "NB! Deactivation process cannot be reversed": "OBS! Inaktiveringsprocessen kan inte ångras",
    "Magic button settings": "Inställningar för magiska knappar",
    "Create only one task per month": "Skapa bara en uppgift per månad",
    "Current month's tasks": "Innevarande månads uppgifter",
    "extra work": "Extra arbete",
    "Without topic": "Utan ämne",
    "Week": "Vecka",
    "Previous month": "Föregående månad",
    "task | tasks": "Uppgift | Uppgifter",
    "Assign to": "Tilldela till",
    "Mark as done": "Markera som klart",
    "Last": "Sista",
    "Snooze": "Tupplur",
    "1 dependency": "1 beroende",
    "{0} dependencies": "{0} beroenden",
    "Client request": "Kundens begäran",
    "Unread notification emails": "Unread notification emails",
    "Unread internal comments": "Unread internal comments",
    "Add comment": "Lägg till kommentar",
    "Internal comment": "Intern kommentar",
    "Portal message": "Meddelande i portalen",
    "Public message means that clients can read it and the client portal will notify them by email": "Offentligt meddelande innebär att kunderna kan läsa det och kundportalen meddelar dem via e-post",
    "Type a comment": "Skriv en kommentar",
    "Send portal message": "Skicka portalmeddelande",
    "Open timesheet": "Öppna tidrapport",
    "Pause timer": "Pausa timer",
    "Mark undone": "Markera som ångrad",
    "Digitise": "Digitalisera",
    "Documents sent to digitisation": "Dokument som skickas till digitalisering",
    "Followers": "Följare",
    "Start / Due date": "Startsida / Förfallodatum",
    "Select topic": "Välj ämne",
    "1 document": "1 dokument",
    "{0} documents": "{0} dokument",
    "Download": "Ladda ner",
    "Download all": "Ladda ner alla",
    "Primary contact": "Primary contact",
    "Assign as task": "Tilldela som uppgift",
    "When selected, the task is sent as a task to the client": "När du väljer det här alternativet skickas uppgiften som en uppgift till klienten",
    "Auto finish": "Automatisk avslutning",
    "When selected, the task is marked done after client finishes it": "När du väljer det här alternativet markeras uppgiften som klar när klienten har slutfört den",
    "Add comment / message": "Lägg till kommentar / meddelande",
    "Add email": "Lägg till e-postadress",
    "Add estimation": "Lägg till uppskattning",
    "Add task field": "Lägg till aktivitetsfält",
    "Add dependency": "Lägg beroende",
    "Drop files to upload": "Dra filer hit för att ladda upp",
    "Task sent to client portal": "Uppgift skickad till kundportalen",
    "Task no longer assigned to client portal": "Uppgiften är inte längre tilldelad till klientportalen",
    "Save recurring task": "Spara återkommande uppgift",
    "Add to-do list": "Lägg till att-göra-lista",
    "Waiting for event status: {0}": "Väntar på händelsestatus: {0}",
    "Waiting for project status: {0}": "Väntar på projektstatus: {0}",
    "Edit template task": "Redigera malluppgift",
    "Create recurring task": "Skapa återkommande uppgift",
    "Make a copy": "Gör en kopia",
    "Add topic": "Nytt ämne",
    "Delete task": "Ta bort uppgift",
    "Delete task template": "Ta bort uppgiftsmall",
    "Select task field": "Välj aktivitetsfält",
    "No custom fields available for this client": "Inga anpassade fält är tillgängliga för den här klienten",
    "task": "uppgift",
    "recurring task": "Återkommande uppgift",
    "Do you intend to remove yourself from {0} or you want to delete it completely?": "Har du för avsikt att ta bort dig själv från {0} eller vill du ta bort det helt?",
    "This {1} is shared with {0}": "Den här {1} delas med {0}",
    "Remove only me": "Ta bort bara mig",
    "Time has been tracked to this task.": "Tiden har spårats till den här uppgiften.",
    "Are you sure to delete this task?": "Är du säker på att du vill ta bort den här uppgiften?",
    "Undefined": "Odefinierad",
    "COPY": "KOPIA",
    "On task due date": "På uppgiftens förfallodatum",
    "{0} day before": "{0} dagen innan",
    "{0} days before": "{0} dagar innan",
    "Edit workflow": "Redigera arbetsflöde",
    "Duplicate project": "Duplicera projekt",
    "Reset layout": "Återställ layout",
    "Any time": "Närsomhelst",
    "1 min": "1 min",
    "5 min": "5 minuter",
    "10 min": "10 min",
    "30 min": "30 min",
    "1 h": "1 t",
    "Add notes": "Lägg till anteckningar",
    "Task start date": "Uppgiftens startdatum",
    "Task due date": "Uppgiftens förfallodatum",
    "Recurrence task": "Återkommande uppgift",
    "Search from one time templates": "Sök från engångsmallar",
    "Placeholders": "Platshållare",
    "New task": "Ny uppgift",
    "New recurring task": "Ny återkommande uppgift",
    "+1 day": "+1 dag",
    "Edit comment": "Redigera kommentar",
    "Timer is running!": "Timern är igång!",
    "Continue time from {0}": "Fortsätt tiden från {0}",
    "New time entry": "Ny tidsangivelse",
    "Load more": "Visa fler",
    "Are you sure to delete this time entry?": "Är du säker på att du vill ta bort den här tidsposten?",
    "Save automated email": "Spara automatisk e-post",
    "Automation": "Automatisering",
    "Are you sure to delete this email?": "Är du säker på att du vill ta bort det här e-postmeddelandet?",
    "Are you sure you wish to send this email immediately?": "Är du säker på att du vill skicka det här e-postmeddelandet omedelbart?",
    "replied to project email": "replied to project email",
    "replied to client email": "replied to client email",
    "commented": "kommenterad",
    "Reply": "Svara",
    "Are you sure to delete this comment?": "Är du säker på att du vill ta bort den här kommentaren?",
    "replied to client portal email": "replied to client portal email",
    "sent a message": "Skickat ett meddelande",
    "replied to task email": "replied to task email",
    "failed to send": "Det gick inte att skicka",
    "sent email": "Skickat e-postmeddelande",
    "no one": "ingen",
    "created this task.": "skapade den här uppgiften.",
    "Task was automatically created from forwarded e-mail": "Task was automatically created from forwarded e-mail",
    "Task was automatically created from client portal e-mail": "Task was automatically created from client portal e-mail",
    "Task was automatically created from client e-mail": "Task was automatically created from client e-mail",
    "Task was automatically created from project e-mail": "Task was automatically created from project e-mail",
    "requested assistance.": "begärt bistånd.",
    "updated this task.": "Den här uppgiften har uppdaterats.",
    "tracked time to this task.": "spårad tid till den här uppgiften.",
    "finished this task.": "slutförde den här uppgiften.",
    "new comment.": "Ny kommentar.",
    "reassigned this task.": "omtilldelad den här uppgiften.",
    "assigned the task to {0}.": "tilldelade uppgiften till {0}.",
    "reminder.": "påminnelse.",
    "deleted.": "borttagen.",
    "completed the task, but Uku did not auto-finish this task because not all task requirements were met.": "slutförde uppgiften, men Uku slutförde inte uppgiften automatiskt eftersom inte alla uppgiftskrav uppfylldes.",
    "sent task to client portal": "Skickade uppgiften till kundportalen",
    "assigned the task to client.": "tilldelade uppgiften till klienten.",
    "assigned the task to company.": "tilldelat uppgiften till företaget.",
    "added attachment(s).": "bifogade filer.",
    "added a comment.": "Lade till en kommentar.",
    "added a message to {0}.": "Ett meddelande har lagts till {0}.",
    "received a e-mail from {0}.": "received a e-mail from {0}.",
    "updated notes.": "Uppdaterade anteckningar.",
    "made changes to checklist.": "Gjorde ändringar i checklistan.",
    "created this task template.": "skapade den här uppgiftsmallen.",
    "updated this task template.": "Den här uppgiftsmallen har uppdaterats.",
    "recurring task assigned.": "återkommande uppgift tilldelad.",
    "recurring task deleted.": "Återkommande uppgift har tagits bort.",
    "added email.": "e-post har lagts till.",
    "changed email.": "ändrad e-postadress.",
    "deleted email.": "raderad e-post.",
    "sent email.": "skickat e-postmeddelande.",
    "failed to send.": "misslyckades med att skicka.",
    "added email": "E-post har lagts till",
    "changed email": "Ändrad e-postadress",
    "deleted email": "Borttagen e-post",
    "Member / Time": "Medlem / Tid",
    "Client/topic": "Klient/ämne",
    "Client/task": "Klient/uppgift",
    "Client/member": "Kund/medlem",
    "Member/topic": "Medlem/ämne",
    "Member/task": "Medlem/uppgift",
    "Member/client": "Medlem/kund",
    "Member/date": "Medlem/datum",
    "Date/member": "Datum/medlem",
    "Grouped": "Grupperad",
    "Client/project": "Beställare/projekt",
    "Project/member": "Projekt/medlem",
    "Period balance": "Periodens saldo",
    "Reset balance": "Återställ saldo",
    "Time entry has been confirmed or duration has been changed and duration will not dynamically update": "Tidsposten har bekräftats eller varaktigheten har ändrats och varaktigheten uppdateras inte dynamiskt",
    "(Without project)": "(Utan projekt)",
    "Decline": "Avböj",
    "Accept": "Acceptera",
    "Cancel decision": "Återkalla beslut",
    "Accepted": "Accepterad",
    "Declined": "Avböjd",
    "Report data has changed. Please update report.": "Rapportdata har ändrats. Uppdatera rapporten.",
    "Agreed": "Överens",
    "Non billable": "Ej fakturerbart",
    "Estimation report shows based on task start date": "Estimation report shows based on task start date",
    "Export report to Excel": "Exportera rapport till Excel",
    "By default, we export the result of the selected filters with the columns of the configured table": "Som standard exporterar vi resultatet av de valda filtren med kolumnerna i den konfigurerade tabellen",
    "Add to export client custom fields": "Lägg till för att exportera anpassade klientfält",
    "Save report": "Spara rapport",
    "Export PDF": "Exportera PDF",
    "Export Excel": "Exportera Excel",
    "Extra": "Extra",
    "done": "klar",
    "h": "t",
    "We have new version of": "Vi har en ny version av",
    "Log out": "Logga ut",
    "Previous day": "Dagen innan",
    "Next day": "Nästa dag",
    "Mark all as read": "Markera allt som läst",
    "Search task/client": "Sök uppgift/klient",
    "from client portal": "Från kundportalen",
    "Hide all": "Dölj alla",
    "Hide for 1 hour": "Göm dig i 1 timme",
    "Something went wrong": "Något gick fel",
    "User authentication needed": "Användarautentisering krävs",
    "Invalid rights": "Ogiltiga rättigheter",
    "The object cannot be found": "Det går inte att hitta objektet",
    "Content too large": "Innehållet är för stort",
    "An unknown error occurred": "Ett okänt fel uppstod",
    "The action requested cannot be performed": "Den begärda åtgärden kan inte utföras",
    "Go": "Start",
    "Actual / monitoring (month)": "Utfall / övervakning (månad)",
    "Actual": "﻿Faktisk",
    "Month": "Månad",
    "I’m setting up your account": "Jag konfigurerar ditt konto",
    "Did you know that accounting firms that have started using Uku can serve 38% more clients in the same time.": "Visste du att redovisningsbyråer som har börjat använda Uku kan betjäna 38 % fler kunder på samma tid.",
    "Let’s setup your company": "Låt oss konfigurera ditt företag",
    "Name of your company": "Namn på ditt företag",
    "Size of your team?": "Storleken på ditt team?",
    "Which software are you using?": "Vilken programvara använder du?",
    "This knowledge will help us to improve Uku": "Denna kunskap kommer att hjälpa oss att förbättra Uku",
    "What other software needs to be integrated?": "Vilken annan programvara behöver integreras?",
    "Book a demo": "Boka demo",
    "Hi {0},": "Hej {0},",
    "NO BOTS - ONLY HUMANS": "INGA ROBOTAR - BARA MÄNNISKOR",
    "Start a {0} day free trial": "Start a {0} day free trial",
    "“Uku is an incredibly functional software. Uku boosted our work management and helps us provide exceptional service.”": "\"Uku är en otroligt funktionell programvara. Uku stärkte vår arbetsledning och hjälper oss att ge exceptionell service.\"",
    "The fastest way for you to decide if Uku can benefit {0} is a short {1} min call with our customer onboarding specialist.": "Det snabbaste sättet för dig att avgöra om Uku kan dra nytta av {0} är ett kort {1} minuters samtal med vår specialist på kundintroduktion.",
    "Hi, I'm Uku ": "Hej, jag heter Uku ",
    "I help to set up your account.": "Jag hjälper till att sätta upp ditt konto.",
    "It only takes a minute.": "Det tar bara en minut.",
    "Choose": "Välj",
    "Your country": "Ditt land",
    "Your language": "Ditt språk",
    "Begin": "Starta",
    "Let’s become friends": "Låt oss bli vänner",
    "Your first name": "Ditt förnamn",
    "What is your field of work?": "Vilket är ditt arbetsområde?",
    "Your field of work": "Ditt arbetsområde",
    "How will you use Uku?": "Hur kommer du att använda Uku?",
    "How did you hear about Uku?": "Hur hörde du talas om Uku?",
    "Choose channel": "Välj kanal",
    "Please specify how you heard about us": "Ange hur du hörde talas om oss",
    "Let me know Uku's new features by email": "Låt mig veta Ukus nya funktioner via e-post",
    "Finish": "Slutför",
    "First name is required": "Förnamn är obligatoriskt",
    "Name is required": "Namn är obligatoriskt",
    "Team size is required": "Lagstorlek krävs",
    "Surname is required": "Efternamn är obligatoriskt",
    "Field is required": "Obligatoriskt fält",
    "I will use Uku to work together with two or more teammates.": "Jag kommer att använda Uku för att arbeta tillsammans med två eller flera lagkamrater.",
    "I will use Uku by myself. This plan is free, but the features are limited.": "Jag kommer att använda Uku själv. Denna plan är gratis, men funktionerna är begränsade.",
    "Media": "Media",
    "Through integration partner": "Genom integrationspartner",
    "Referral by friend": "Hänvisning av vän",
    "Import speeds up your clients setup, smart choice!": "Import snabbar upp dina kunders installation, smart val!",
    "Last import: added {0}, updated {1}, skipped {2}, failed to import {3} client": "Senaste import: lade till {0}, uppdaterade {1}, hoppade över {2}, kunde inte importera {3} klient",
    "Last import: added {0}, updated {1}, skipped {2}, failed to import {3} clients": "Senaste import: lade till {0}, uppdaterade {1}, hoppade över {2}, kunde inte importera {3} klienter",
    "Last import: added {0}, updated {1}, skipped {2}": "Senaste import: lagt till {0}, uppdaterat {1}, hoppat över {2}",
    "What's next? Correct the data of {0} clients and upload again.": "Vad händer härnäst? Korrigera data för {0} klienter och ladda upp igen.",
    "failed_to_import.xlsx": "failed_to_import.xlsx",
    "Excel (XLS, XLSX) ": "Excel (XLS, XLSX) ",
    "Instead of entering clients one by one, you can use file import for a large customer base.": "Istället för att ange kunder en efter en kan du använda filimport för en stor kundbas.",
    "Ignore": "Ignorera",
    "NEW CLIENT": "NY KUND",
    "Preview": "Förhandsvisa",
    "Import started": "Importen har startats",
    "Only new clients": "Endast nya kunder",
    "Update data from company register": "Uppdatera uppgifter från företagsregistret",
    "If switched on, the company data is updated using the local business register": "Om den är aktiverad uppdateras företagsuppgifterna med hjälp av det lokala företagsregistret",
    "We did not find a match in Äriregister": "Vi hittade ingen matchning i Äriregister",
    "We did not find a match in Companies House": "Vi hittade ingen matchning i Companies House",
    "No integration yet": "Ingen integration ännu",
    "Uku match": "Uku match",
    "Business register nr.": "Företagsregistrets nr.",
    "Company register": "Företagsregister",
    "Upload file": "Ladda upp fil",
    "Before uploading your file": "Innan du laddar upp din fil",
    "Learn Uku’s data structure": "Lär dig Ukus datastruktur",
    "Download and use our sample file to see exactly how we organize data in Uku": "Ladda ner och använd vår exempelfil för att se exakt hur vi organiserar data i Uku",
    "Download Client Import Example": "Ladda ned exempel på klientimport",
    "Download Contact Import Example": "Ladda ner exempel på kontaktimport",
    "Fill in fields": "Fyll i fält",
    "The only mandatory field is the company name. Make sure you've filled out all the necessary fields before uploading the file.": "Det enda obligatoriska fältet är företagsnamnet. Se till att du har fyllt i alla nödvändiga fält innan du laddar upp filen.",
    "Learn more about mandatory fields": "Läs mer om obligatoriska fält",
    "Create custom fields": "Skapa anpassade fält",
    "Some data fields may not be present by default. Make sure you create these custom fields before importing your data.": "Vissa datafält kanske inte finns som standard. Se till att du skapar dessa anpassade fält innan du importerar dina data.",
    "Add new custom fields": "Lägga till nya anpassade fält",
    "...or drag a file here": "... eller dra en fil hit",
    "Only Excel (.xls, .xlsx) file types are supported": "Endast Excel-filtyper (.xls, .xlsx) stöds",
    "Mapping": "Kartläggning",
    "First row is a header": "Första raden är en rubrik",
    "Add field to all clients": "Lägg till fält till alla klienter",
    "Add client group": "Lägg till klientgrupp",
    "Fields for all clients": "Fält för alla klienter",
    "Import of {0} in progress": "Import av {0} pågår",
    "Import in progress": "Import pågår",
    "It may take some time. You can do other activities in Uku at the same time, we will let you know when it is ready.": "Det kan ta lite tid. Du kan göra andra aktiviteter i Uku samtidigt, vi meddelar dig när det är klart.",
    "Cancel import": "Avbryt import",
    "Are you sure you want to cancel import?": "Är du säker på att du vill avbryta importen?",
    "Last updated": "Senast uppdaterad",
    "Contracts": "Avtal",
    "Job name": "Jobbnamn",
    "Workflow name": "Namn på arbetsflöde",
    "Details": "Detaljer",
    "Select jobs": "Välj jobb",
    "Select task plan": "Välj uppgiftsplan",
    "of existing client": "av befintliga kunder",
    "You can also choose": "Du kan också välja",
    "existing client tasks plan": "Befintlig plan för klientuppgifter",
    "existing predefined jobs": "Befintliga fördefinierade jobb",
    "create a new plan": "Skapa en ny plan",
    "Select workflow": "Välj arbetsflöde",
    "existing project workflow": "Befintligt projektarbetsflöde",
    "existing workflow": "Befintligt arbetsflöde",
    "create a new workflow": "Skapa ett nytt arbetsflöde",
    "New tasks template": "Ny uppgiftsmall",
    "to save template!": "för att spara mallen!",
    "You can also add tasks from jobs": "Du kan också lägga till uppgifter från jobb",
    "or choose": "eller välj",
    "New workflow template": "Ny arbetsflödesmall",
    "You can also add tasks from existing workflow templates": "Du kan också lägga till uppgifter från befintliga arbetsflödesmallar",
    "existing event workflow": "Befintligt händelsearbetsflöde",
    "Hide others": "Dölj andra",
    "Update all events (New tasks)": "Uppdatera alla händelser (nya uppgifter)",
    "Update all projects (New tasks)": "Uppdatera alla projekt (Nya uppgifter)",
    "Once": "En gång",
    "Once a month": "En gång i månaden",
    "Once a quarter": "En gång i kvartalet",
    "Once a year": "En gång om året",
    "Company workflow": "Arbetsflöde för företag",
    "Company jobs": "Företag jobb",
    "Default jobs": "Standardjobb",
    "ID": "ID",
    "Task title and labels": "Uppgiftens titel och etiketter",
    "Assigned and time": "Tilldelad och tid",
    "Setup tasks for {0} event": "Konfigurera uppgifter för {0} händelse",
    "Setup tasks for {0} project": "Konfigurera uppgifter för {0} projekt",
    "New job": "Nytt jobb",
    "Edit job": "Redigera tjänst",
    "New workflow": "Nytt arbetsflöde",
    "Save workflow": "Spara arbetsflöde",
    "Confirm task plan": "Bekräfta uppgiftsplan",
    "Skip": "Hoppa över",
    "Create task plan": "Skapa arbetsplan",
    "Edit task plan": "Edit task plan",
    "Confirm workflow": "Bekräfta arbetsflöde",
    "Client portal templates": "Mallar för klientportaler",
    "Jobs": "Jobb",
    "Workflows": "Arbetsflöden",
    "Company workflows": "Arbetsflöden för företag",
    "Default workflows": "Standardarbetsflöden",
    "Company template saved": "Företagsmall sparad",
    "Company template created": "Företagsmall skapad",
    "Format": "Format",
    "Currency": "Valuta",
    "Reference number": "Referens",
    "Invoice description": "Beskrivning av fakturan",
    "Summarize invoice rows": "Summera fakturarader",
    "Summarized description": "Sammanfattad beskrivning",
    "Reverse charge": "Omvänd skattskyldighet",
    "Rounding": "Avrundning",
    "Time rounding will apply for each line": "Tidsavrundning gäller för varje rad",
    "Rounding increment (up)": "Avrundningssteg (uppåt)",
    "Reply to": "Svara till",
    "Configuration": "Konfiguration",
    "Invoice to parent company": "Faktura till moderbolaget",
    "Create all invoices under parent company.": "Skapa alla fakturor under moderbolaget.",
    "User code": "Användarkod",
    "Default": "Standard",
    "Default value will apply for each line": "Standardvärdet gäller för varje rad",
    "Number": "Nummer",
    "You can write any of the following in curly braces to invoice prefix field. When saving the contract the prefix is filled with the corresponding value.": "Du kan skriva något av följande i fältet klammerparenteser för fakturaprefix. När du sparar kontraktet fylls prefixet med motsvarande värde.",
    "Copy to clipboard": "Kopiera till urklipp",
    "Invoice previous period": "Faktura föregående period",
    "Invoice period": "Fakturaperiod",
    "Invoice next period": "Fakturera nästkommande period",
    "Client primary user": "Primär klientanvändare",
    "Original client name": "Ursprungligt klientnamn",
    "invoice date year": "Fakturadatum År",
    "last two digits of invoice date year": "De två sista siffrorna i fakturadatum år",
    "invoice date month": "Fakturadatum Månad",
    "invoice date day": "Datum för faktura Dag",
    "Contract": "Kontrakt",
    "Net total": "Net total",
    "Contract #": "Kontrakt #",
    "Invoice #": "Faktura #",
    "Exported": "Exporterad",
    "Sent": "Skickat",
    "Net": "Netto",
    "Add invoice": "Lägg till faktura",
    "Change invoice number": "Ändra fakturanummer",
    "Review changes": "Granska ändringar",
    "Please review and approve changes to the related events": "Granska och godkänn ändringar av relaterade händelser",
    "Please review and approve changes to the related projects": "Granska och godkänn ändringar i relaterade projekt",
    "Contains": "Innehåller",
    "contains": "innehåller",
    "Exactly": "Exakt",
    "is exactly": "är exakt",
    "Greater than": "Större än",
    "is greater than": "är större än",
    "Less than": "Mindre än",
    "is less than": "är mindre än",
    "Range": "Intervall",
    "is in range of": "är inom räckhåll för",
    "is empty": "är tom",
    "Task plan": "Uppgiftsplan",
    "Edit plan": "Redigera plan",
    "Use task plan templates to set up tasks effectively or add a task manually": "Använd uppgiftsplanmallar för att ställa in uppgifter effektivt eller lägga till en uppgift manuellt",
    "Add task manually": "Lägga till uppgift manuellt",
    "Quarterly": "Kvartalsvis",
    "Export excel": "Exportera excel",
    "Print PDF": "Skriv ut PDF",
    "Edit jobs": "Redigera jobb",
    "Replace plan tasks with job": "Ersätt planaktiviteter med projekt",
    "Select template": "Välj mall",
    "member": "medlem",
    "Tasks with user will be added to every selected client": "Uppgifter med användaren kommer att läggas till i varje vald klient",
    "Add even if job already applied": "Lägg till även om jobbet redan har sökts",
    "Default user": "Standardanvändare",
    "This will delete all tasks from client plan and put only selected template’s tasks in it": "Detta kommer att ta bort alla uppgifter från klientplanen och endast lägga till den valda mallens uppgifter i den",
    "Adding template will be ready in a minute. You can continue with work.": "Att lägga till mall är klart på en minut. Du kan fortsätta med arbetet.",
    "Add client": "Lägg till kund",
    "Export clients": "Exportera klienter",
    "Export client contacts": "Exportera kundkontakter",
    "client | clients": "Beställare | Klienter",
    "clients": "kunder",
    "client(s) had errors": "Kund(er) hade fel",
    "client(s) selected": "Kund(er) valda",
    "Contract actions": "Kontraktsåtgärder",
    "Edit Members": "Redigera medlemmar",
    "Edit monitoring": "Redigera övervakning",
    "Your company": "Ditt företag",
    "Edit billing": "Redigera fakturering",
    "Activate client portal": "Aktivera kundportalen",
    "After activation, you can send tasks directly to all client's contacts who have an e-mail address.": "Efter aktiveringen kan du skicka uppgifter direkt till alla klientens kontakter som har en e-postadress.",
    "Send welcome invitation to client contacts": "Skicka välkomstinbjudan till kundkontakter",
    "Who will receive an invitation?": "Vem får en inbjudan?",
    "Client contact who has one valid e-mail address": "Kundkontakt som har en giltig e-postadress",
    "Client contact who has the client's portal open (default for all)": "Kundkontakt som har klientens portal öppen (standard för alla)",
    "How does the invitation work?": "Hur fungerar inbjudan?",
    "Uku creates and sends a 'Welcome task' to each client contact. It's created by the client primary user based on the 'Welcome to the Customer Portal' task template. Check it out under your company task templates. It will be translated according to the contact language.": "Uku skapar och skickar en \"välkomstuppgift\" till varje kundkontakt. Den skapas av klientens primära användare baserat på uppgiftsmallen \"Välkommen till kundportalen\". Kolla in det under dina mallar för företagsuppgifter. Den kommer att översättas enligt kontaktspråket.",
    "Uku client portal always informs clients by email about new tasks.": "Uku kundportal informerar alltid kunder via e-post om nya uppgifter.",
    "View templates": "Visa mallar",
    "Client portal activated": "Kundportalen aktiverad",
    "Company's name": "Företagets namn",
    "Mark": "Markera",
    "Add members": "Lägg till medlemmar",
    "Members and groups": "Medlemmar och grupper",
    "Topic is required": "Ämne är obligatoriskt",
    "Entering time is required": "Inmatningstid krävs",
    "Delete client": "Ta bort klient",
    "Manage client fields": "Hantera klientfält",
    "Max 3 characters": "Max 3 tecken",
    "Are you sure you wish to delete this client?": "Är du säker på att du vill ta bort den här klienten?",
    "Deleting client data will also delete all client-related tasks.<br/><br/>NB! Client history will be deleted": "Om du tar bort klientdata tas även alla klientrelaterade uppgifter bort.<br/><br/>OBS! Klienthistoriken kommer att raderas",
    "Owner": "Ägare",
    "All clients that you add under {0} will be deleted later.</div>": "Alla klienter som du lägger till under {0} kommer att tas bort senare.",
    "Use this account for testing purposes only!": "Använd det här kontot endast i testsyfte!",
    "Read more about the demo account": "Läs mer om demokontot",
    "Rights": "Rättigheter",
    "Monitoring setup": "Konfiguration av övervakning",
    "Learn more about monitoring": "Läs mer om övervakning",
    "selected": "vald",
    "Resend": "Resend",
    "Invoicing": "Fakturering",
    "Billing template": "Mall för fakturering",
    "New": "Nytt",
    "Add row": "Lägg till rad",
    "Delete contract": "Ta bort kontrakt",
    "Product / description": "Produkt / beskrivning",
    "Qty": "Antal",
    "Product placeholders": "Platshållare för produkter",
    "You can write any of the following lines in curly brackets to product description. When saving an invoice it will replace the text with the corresponding value.": "You can write any of the following lines in curly brackets to product description. When saving an invoice it will replace the text with the corresponding value.",
    "Template saved": "Mall sparad",
    "Warning": "Varning",
    "Would you like to apply these changes to all clients using this contract template?": "Vill du tillämpa dessa ändringar på alla kunder som använder den här avtalsmallen?",
    "Yes, apply to all clients": "Ja, gäller för alla kunder",
    "You have made changes to time period that this billing contract applies to. This may change how affected unbilled services in the past and future will be invoiced. Please confirm that this change was intentional.": "Du har gjort ändringar i den tidsperiod som detta faktureringsavtal gäller för. Detta kan ändra hur påverkade ofakturerade tjänster i det förflutna och i framtiden kommer att faktureras. Bekräfta att ändringen var avsiktlig.",
    "Are you sure to delete this template?": "Är du säker på att ta bort den här mallen?",
    "Save template": "Spara mall",
    "Save as template": "Spara som mall",
    "Please note all changes made to contract will be lost": "Observera att alla ändringar som görs i avtalet kommer att gå förlorade",
    "Add contract": "Lägg till kontrakt",
    "Manage contract templates": "Hantera avtalsmallar",
    "Edit account details": "Ändra kontouppgifter",
    "Country is required": "Land krävs",
    "Postal code": "Postnummer",
    "State": "Län",
    "Uku is set up according to the field of work.": "Uku är uppbyggd efter arbetsområde.",
    "Size of the team": "Teamets storlek",
    "Website": "Website",
    "Delete account": "Ta bort konto",
    "Deleting an account will also delete all clients associated with the account, their tasks, and their entire history. Are you sure that you want to delete your account?": "Om du tar bort ett konto raderas också alla kunder som är kopplade till kontot, deras uppgifter och hela deras historik. Är du säker på att du vill ta bort ditt konto?",
    "Yes, delete the account with all related data such as clients, tasks, and all history": "Ja, ta bort kontot med all relaterad data som kunder, uppgifter och all historik",
    "These invoices cannot be sent. Check their status or error messages.": "Dessa fakturor kan inte skickas. Kontrollera deras status eller felmeddelanden.",
    "Please confirm that you wish to proceed.": "Bekräfta att du vill fortsätta.",
    "Sending invoice | Sending invoices": "Skicka faktura | Skicka fakturor",
    "You are about to e-mail this invoice to customer. | You are about to e-mail these invoices to customers.": "Du är på väg att e-posta denna faktura till kunden. | Du är på väg att e-posta dessa fakturor till kunder.",
    "Error in calculating invoice": "Fel vid beräkning av faktura",
    "Error in importing invoice": "Fel vid import av faktura",
    "Error in creating invoice": "Fel vid skapande av faktura",
    "Error in exporting invoice": "Fel vid export av faktura",
    "Error in sending invoice": "Fel vid sändning av faktura",
    "Calculating invoice": "Beräkna faktura",
    "Creating invoice": "Skapa faktura",
    "Exporting invoice": "Exportera faktura",
    "Importing invoice": "Importera faktura",
    "Sending invoice": "Skicka faktura",
    "Clear errors": "Tydliga fel",
    "Related work will be made billable again. The invoices will not be deleted from external systems, you will have to do that manually.": "Relaterat arbete kommer att göras fakturerbart igen. Fakturorna kommer inte att raderas från externa system, du måste göra det manuellt.",
    "Delete invoice | Deleting invoices": "Ta bort faktura | Ta bort fakturor",
    "Selected net total": "Selected net total",
    "Nothing in invoices": "Ingenting i fakturor",
    "Please make sure you have setup recurring billing for your clients": "Se till att du har ställt in återkommande fakturering för dina kunder",
    "Draft": "Utkast",
    "Approval": "Acceptera",
    "Created": "Skapad",
    "Coming soon": "Kommer snart",
    "Selected invoices and related product info will be sent to accounting system.": "Utvalda fakturor och tillhörande produktinfo kommer att skickas till ekonomisystemet.",
    "Piece": "Bit",
    "Hour": "Timme",
    "Delete row": "Radera rad",
    "Out of ": "Ur ",
    " can be created": " kan skapas",
    "For ": "För ",
    " invoicing period is still ongoing. Any work done in this period after creation of the invoice will not be invoiced.": " faktureringsperioden pågår fortfarande. Allt arbete som utförs under denna period efter att fakturan har skapats kommer inte att faktureras.",
    "Invoice date will be set to today.": "Fakturadatum kommer att sättas till idag.",
    "Uku is about to create": "Uku är på väg att skapa",
    " selected row, only | selected row, only ": " Endast markerad rad | Endast markerad rad ",
    " invoice | invoices": " Faktura | Fakturor",
    "These invoices cannot be exported. Check their status or error messages.": "Dessa fakturor kan inte exporteras. Kontrollera deras status eller felmeddelanden.",
    "Exporting invoice | Exporting invoices": "Exportera faktura | Exportera fakturor",
    "You are about to export this invoice to accounting. | You are about to export these invoices to accounting.": "Du håller på att exportera den här fakturan till bokföringen. | Du håller på att exportera dessa fakturor till bokföringen.",
    "This invoice has already been exported. Are you sure you want to export it as a new invoice? | Some of these invoices have already been exported. Are you sure that you want to export them as new invoices?": "This invoice has already been exported. Are you sure you want to export it as a new invoice? | Some of these invoices have already been exported. Are you sure that you want to export them as new invoices?",
    "Download pdf": "Ladda ner PDF",
    "Create invoice": "Skapa faktura",
    "Update status from {0}": "Uppdatera status från {0}",
    "Show all lines": "Visa alla rader",
    "Calculate invoice": "Beräkna faktura",
    "Loading invoice...": "Laddar faktura...",
    "Invalid Scoro credentials": "Ogiltiga Scoro-uppgifter",
    "Please confirm the changes you have made to this invoice.": "Bekräfta de ändringar du har gjort på den här fakturan.",
    "NB! Note that changed invoice will not be automatically sent to customer or exported to external systems - you will have to do this manually.": "OBS! Observera att ändrad faktura inte automatiskt kommer att skickas till kund eller exporteras till externa system - du måste göra detta manuellt.",
    "Invoice number already exists! Please confirm to save anyway.": "Fakturanummer finns redan! Bekräfta att spara ändå.",
    "Error in data": "Fel i data",
    "The invoicing period is still ongoing. Any work done in this period after creation of the invoice will not be invoiced.": "Faktureringsperioden pågår fortfarande. Allt arbete som utförs under denna period efter att fakturan har skapats kommer inte att faktureras.",
    "Creation date": "Skapat  datum",
    "{0} days after": "{0} dagar efter",
    "{0} day after": "{0} dagen efter",
    "right away when": "direkt när",
    "start date": "startdatum",
    "due date": "deadline",
    "finished": "färdig",
    "Entries count": "Antal poster",
    "Entries excluding sales": "Poster exklusive försäljning",
    "Entries excluding bank": "Poster exklusive bank",
    "Entries excluding documents": "Poster exklusive dokument",
    "Documents (sales and purchases)": "Dokument (försäljning och inköp)",
    "Cash entries": "Kontanta inspel",
    "VAT entries": "Bokföring av moms",
    "Stock entries": "Registrering av lager",
    "Sale entries": "Transaktioner för försäljning",
    "Purchase entries": "Inköpstransaktioner",
    "Bank entries": "Bankposter",
    "Ledger entries": "Transaktioner",
    "Depreciation entries": "Avskrivningstransaktioner",
    "Entry lines count": "Antal inmatningsrader",
    "Transaction create": "Transaction create",
    "Transaction update": "Transaction update",
    "Purchase invoice create": "Purchase invoice create",
    "Purchase invoice update": "Purchase invoice update",
    "Sales invoice create": "Sales invoice create",
    "Sales invoice update": "Sales invoice update",
    "Financial entry create": "Financial entry create",
    "Financial entry update": "Financial entry update",
    "Expense row create": "Expense row create",
    "Expense row update": "Expense row update",
    "Depreciation create": "Depreciation create",
    "Depreciation update": "Depreciation update",
    "Person count": "Person count",
    "Fixed assets": "Fixed assets",
    "Company owner": "Företagets ägare",
    "Activity": "Aktivitet",
    "Oldest first": "Äldsta först",
    "Newest first": "Nyaste först",
    "Quantity as time": "Kvantitet som tid",
    "Quantity as number": "Antal som antal",
    "Quantity as time in number format": "Antal som tid i talformat",
    "No rounding": "Ingen avrundning",
    "min": "min",
    "hour": "timme",
    "Last day of month": "Sista dagen i månaden",
    "Invoice line": "Fakturarad",
    "Task time total (per member)": "Uppgiftstid totalt (per medlem)",
    "Time entry": "Tidsangivelse",
    "Task finish date": "Slutdatum för uppgift",
    "Create separately": "Skapa separat",
    "Merge into one": "Sammanfoga till en",
    "No minimum": "Inga lägsta belopp",
    "{0} minute": "{0} minut",
    "{0} minutes": "{0} minuter",
    "{0} hour": "{0} timme",
    "{0} hours": "{0} timmar",
    "English": "Engelska",
    "Estonian": "Estniska",
    "Danish": "Danska",
    "Lithuanian": "Litauiska",
    "Russian": "Ryska",
    "Finnish": "Finska",
    "Swedish": "Svenska",
    "Norwegian": "Norge",
    "Latvian": "Lettiska",
    "Bulgarian": "Bulgarien",
    "German": "Tyska",
    "Spanish": "Spanska",
    "Polish": "Polska",
    "Field: ": "Fält: ",
    "Normal hours": "Normala öppettider",
    "Year": "År",
    "Estonia": "Estland",
    "Finland": "Finland",
    "Poland": "Polen",
    "User": "Användare",
    "None": "Ingen",
    "Error!": "Fel!",
    "Pending": "Väntande",
    "Finished": "Avslutade",
    "Text": "Text",
    "Choice": "Val",
    "Yes/No": "Ja/Nej",
    "Integer": "Heltal",
    "Multiple choice": "Flerval",
    "URL": "URL",
    "Multiple users": "Flera användare",
    "Multiline text": "Text med flera rader",
    "Must be a integer": "Måste vara ett heltal",
    "Must be a date": "Måste vara ett datum",
    "Must be a valid e-mail address": "Måste vara en giltig e-postadress",
    "Unknown choice": "Okänt val",
    "Some errors occurred:": "Några fel uppstod:",
    "Unknown network error": "Okänt nätverksfel",
    "Could not connect to the service": "Det gick inte att ansluta till tjänsten",
    "Reload this page": "Ladda om den här sidan",
    "Invoice paid": "Fakturan betald",
    "Annulled": "Ogiltigförklarade",
    "Processing": "Bearbetas",
    "You are about to deactivate this app.": "Du är på väg att inaktivera den här appen.",
    "You are about to disconnect this app.": "Du är på väg att koppla bort den här appen.",
    "Do you also want to activate billing to get the most out of Uku?": "Vill du också aktivera fakturering för att få ut det mesta av Uku?",
    "Invoice": "Faktura",
    "Clients - Monitoring": "Klienter – övervakning",
    "Links": "Länkar",
    "New template": "Skapa ny mall",
    "Import Clients from Excel": "Importera klienter från Excel",
    "Importer": "Importör",
    "Import clients from Excel": "Importera klienter från Excel",
    "Account settings": "Kontoinställningar",
    "Empty": "Tomt",
};
export default translations